(function () {
  'use strict';
  var C=window.VBMQuoteCore;
  if(!C)return;
  if (window.__vbmQuoteBootstrap&&window.__vbmQuoteBuild===C.VERSION) { window.__vbmQuoteBootstrap(document); return; }
  var E=C.escape;
  var LABELS={project:"__VBM_TEXT_t001__",vensterbanken:"__VBM_TEXT_t002__",maten:"__VBM_TEXT_t003__",diensten:"__VBM_TEXT_t004__",advies:"__VBM_TEXT_t005__",gegevens:"__VBM_TEXT_t006__",controle:"__VBM_TEXT_t007__"};
  var ROUTES={offerte:'Offerteaanvraag',inmeten:'Inmeetverzoek',advies:'Adviesaanvraag',showroom:'Verzoek showroomafspraak'};
  function attrs(values){return Object.keys(values).filter(function(k){return values[k]!==false&&values[k]!=null;}).map(function(k){return ' '+k+'="'+E(values[k]===true?'':values[k])+'"';}).join('');}
  function question(attributes){return attrs({'data-question':attributes['data-c']||attributes['data-s']||attributes['data-b']||attributes['data-variant']||'field','data-question-bank':attributes['data-bank']});}
  function input(label,attributes,hint){
    var id=attributes.id||('q-'+(attributes['data-c']||attributes['data-s']||attributes['data-b']||C.uid())+'-'+(attributes['data-bank']||'project'));
    return '<div class="q-field"'+question(attributes)+'><label class="q-label" for="'+E(id)+'">'+E(label)+'</label><input'+attrs(Object.assign({id:id,type:'text'},attributes))+'>'+(hint?'<p class="q-hint">'+E(hint)+'</p>':'')+'</div>';
  }
  function select(label,attributes,values,selected,hint,placeholder){
    var id=attributes.id||('q-'+(attributes['data-c']||attributes['data-s']||attributes['data-b']||C.uid())+'-'+(attributes['data-bank']||'project'));
    var options=(placeholder===false?'':'<option value="">'+E(placeholder||"__VBM_TEXT_t008__")+'</option>')+values.map(function(v){var value=Array.isArray(v)?v[0]:v.value;var name=Array.isArray(v)?v[1]:v.label;return '<option value="'+E(value)+'"'+(String(value)===String(selected)?' selected':'')+'>'+E(name)+'</option>';}).join('');
    return '<div class="q-field"'+question(attributes)+'><label class="q-label" for="'+E(id)+'">'+E(label)+'</label><select'+attrs(Object.assign({id:id},attributes))+'>'+options+'</select>'+(hint?'<p class="q-hint">'+E(hint)+'</p>':'')+'</div>';
  }
  function textarea(label,attributes,value,hint){
    var id=attributes.id||('q-'+(attributes['data-s']||attributes['data-b']||C.uid())+'-'+(attributes['data-bank']||'project'));
    return '<div class="q-field"'+question(attributes)+'><label class="q-label" for="'+E(id)+'">'+E(label)+'</label><textarea'+attrs(Object.assign({id:id,rows:4},attributes))+'>'+E(value)+'</textarea>'+(hint?'<p class="q-hint">'+E(hint)+'</p>':'')+'</div>';
  }
  function choices(label,key,values,selected,bankId,columns){
    return '<fieldset class="q-question" data-question="'+E(key)+'"'+attrs({'data-question-bank':bankId})+'><legend>'+E(label)+'</legend><div class="q-grid '+(columns===3?'q-grid-3':'')+'">'+values.map(function(v){
      return '<label class="q-choice"><input type="radio"'+attrs({name:key+'-'+(bankId||'project'),value:v[0],'data-b':bankId?key:null,'data-bank':bankId,'data-s':bankId?null:key,checked:selected===v[0]})+'><span><strong>'+E(v[1])+'</strong>'+(v[2]?'<small>'+E(v[2])+'</small>':'')+'</span></label>';
    }).join('')+'</div></fieldset>';
  }
  function check(label,attributes,checked){var key=attributes['data-b'];return '<label class="q-check"'+(key?attrs({'data-question':key==='endcap'?'endcap-request':key}):'')+'><input type="checkbox"'+attrs(Object.assign({checked:checked},attributes))+'><span>'+E(label)+'</span></label>';}
  function button(text,action,secondary,extra){return '<button type="button" class="q-button'+(secondary?' q-button--secondary':'')+'" data-action="'+E(action)+'"'+attrs(extra||{})+'>'+E(text)+'</button>';}
  function link(text,action,extra){return '<button type="button" class="q-link" data-action="'+E(action)+'"'+attrs(extra||{})+'>'+E(text)+'</button>';}
  function image(url,alt){if(!url)return '<span class="q-choice-svg" aria-hidden="true">'+drawing('new')+'</span>';try{var u=new URL(url,window.location.href);if(!['http:','https:'].includes(u.protocol))return '';}catch(e){return '';}return '<img src="'+E(url)+'" alt="'+E(alt)+'" loading="lazy">';}
  function drawing(type){
    return '<svg viewBox="0 0 260 145" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M40 81h155v52H40z" fill="#e8e4ed"/><path d="M21 14h11v119H21z" fill="#d8cfdf"/><path d="M33 16h9v46h-9z" fill="#f6f2fa" stroke="#b9afc7" stroke-width="1.5"/>'+(type==='overzet'?'<path d="M32 70h188v18H32z" fill="#aaa4b2" stroke="#8b8396" stroke-width="1.5"/><path d="M30 59h202v48h-12V71H30V59Z" fill="currentColor" stroke="currentColor" stroke-width="1.5"/>':'<path d="M31 65h192a5 5 0 0 1 5 5v11H31V65Z" fill="currentColor"/><path d="M42 84h151" stroke="#b9afc7" stroke-width="3" stroke-dasharray="5 4"/>')+'<path d="M16 134h228" stroke="#d8cfdf" stroke-width="1.5"/></svg>';
  }
  function safeRead(key){try{return JSON.parse(sessionStorage.getItem(key)||'null');}catch(e){return null;}}
  function safeWrite(key,value){try{sessionStorage.setItem(key,JSON.stringify(value));return true;}catch(e){return false;}}
  function safeRemove(key){try{sessionStorage.removeItem(key);}catch(e){}}
  function initialUI(token){return {active:null,errors:[],productSearch:'',showProductPicker:false,showMaterials:false,colorSearch:'',colorAll:false,colorPickerOpen:false,navigationToken:token||0,loading:null,catalogError:null,productError:null,resume:null,photoTarget:'',pendingPhotos:[],submitting:false,returnToReview:false,restartConfirm:false};}
  function hasRequestContent(state){return !!(state&&(state.materialKnown||state.expectedCount||state.banks.length||state.photos.length||state.installation||state.measurement||state.delivery||state.adviceKind||state.adviceTopic||state.preferredDate||state.preferredPart||state.timing||state.message||Object.values(state.contact||{}).some(function(value){return !!value;})));}
  var activeQuote=null,editorReopen=false;
  function cleanSource(){try{var u=new URL(document.referrer);return u.origin+u.pathname;}catch(e){return '';}}
  function Quote(root){
    this.root=root;this.config=JSON.parse(root.querySelector('[data-quote-config]').textContent);
    this.form=root.querySelector('form');this.key=this.config.globalPopup?(this.config.storageKey||'vbm-quote-global-v1'):'vbm-quote-v1:'+location.pathname+':'+this.config.sectionId;
    this.pendingKey=this.key+':pending';this.doneKey=this.key+':done';
    this.state=C.initial();this.state.source=cleanSource();
    this.ui=initialUI();
    this.catalogs=new Map();this.productSpecs=new Map();this.colors=null;
    this.setupDialog();
    if(!this.config.globalPopup&&root.querySelector('[data-quote-success]')){this.open();this.success();return;}
    if(!this.form)return;
    this.content=root.querySelector('[data-step-content]');this.actions=root.querySelector('[data-actions]');
    this.photoPanel=root.querySelector('[data-photo-panel]');this.upload=root.querySelector('[data-vbm-uploader]');
    var layout=document.createElement('div');layout.className='q-layout';this.form.parentNode.insertBefore(layout,this.form);layout.appendChild(this.form);
    this.aside=document.createElement('aside');this.aside.className='q-aside';this.aside.setAttribute('aria-label',this.resolveText("__VBM_TEXT_t009__"));layout.appendChild(this.aside);
    var draft=C.migrate(safeRead(this.key));
    if(!draft&&this.config.globalPopup){
      try{for(var i=0;i<sessionStorage.length;i++){var key=sessionStorage.key(i);if(key&&key.startsWith('vbm-quote-v1:')&&!/:(pending|done)$/.test(key)){var prior=C.migrate(safeRead(key));if(prior&&(!draft||prior.updatedAt>draft.updatedAt))draft=prior;}}}catch(e){}
    }
    var ownResponse=this.receiptMatches();
    if(draft){
      if(root.querySelector('[data-shopify-error]')&&ownResponse)this.state=draft;
      else this.ui.resume=draft;
    }
    this.bind();this.render();
    if(!this.config.globalPopup){this.loadColors();this.applyPrefill();}
    var nativeError=root.querySelector('[data-shopify-error]');if(nativeError)nativeError.hidden=this.config.globalPopup&&!ownResponse;
    if(nativeError&&ownResponse){this.open();this.refreshRestored();this.jumpTo(nativeError);}
    if(this.config.globalPopup&&root.querySelector('[data-quote-success]')&&ownResponse){this.showSuccess();}
    var self=this;
    this.uploadObserver=new MutationObserver(function(){self.photoAvailability();});
    this.uploadObserver.observe(this.upload,{childList:true,subtree:true});
    window.setTimeout(function(){self.photoAvailability(true);},7000);
  }

  var TEXT_DEFAULTS={
  "mail_prepare_error": "Je aanvraag kon niet worden voorbereid. Je antwoorden zijn bewaard. Probeer het opnieuw of neem contact met ons op.",
  "reset_label": "Opnieuw beginnen",
  "reset_heading": "Opnieuw beginnen?",
  "reset_body": "Je antwoorden en foto’s worden uit deze aanvraag verwijderd.",
  "reset_confirm_label": "Ja, opnieuw beginnen",
  "reset_cancel_label": "Verder met deze aanvraag",
  "reset_notice": "Je kunt een nieuwe aanvraag invullen.",
  "dialog_title": "Jouw offerteaanvraag",
  "dialog_label": "Offerteaanvraag voor vensterbanken",
  "close_label": "Sluit offerteaanvraag",
  "success_badge": "Aanvraag ontvangen",
  "success_title": "Bedankt voor je aanvraag.",
  "success_body": "We bekijken je wensen en nemen binnen 3 werkdagen persoonlijk contact met je op.",
  "restart_label": "Nieuwe aanvraag",
  "server_error_title": "Je aanvraag is nog niet verstuurd.",
  "server_error_body": "Controleer de melding hieronder. Je eerdere keuzes worden waar mogelijk teruggezet.",
  "loading_label": "Je aanvraaghulp wordt geladen.",
  "photo_title": "Foto’s van je situatie (optioneel)",
  "photo_hint": "Je kunt meerdere foto’s toevoegen.",
  "photo_target": "Bij welke vensterbank horen de foto’s?",
  "photo_general": "Algemene situatie",
  "photo_loading": "Foto’s toevoegen wordt geladen. Je kunt je aanvraag ook zonder foto’s versturen.",
  "photo_limit": "Maximaal 10 megabyte per foto.",
  "privacy_body": "We gebruiken je gegevens om je aanvraag te behandelen en contact met je op te nemen.",
  "privacy_link": "Lees ons privacybeleid",
  "t001": "Jouw project",
  "t002": "Vensterbanken",
  "t003": "Maten en situatie",
  "t004": "Diensten",
  "t005": "Advies of showroom",
  "t006": "Je gegevens",
  "t007": "Controleren",
  "t008": "Maak een keuze",
  "t009": "Jouw aanvraag",
  "t010": "Ongeldige collectie.",
  "t011": "De collectie kon niet worden geladen.",
  "t012": "Deze collectie is te groot om in één keer te openen.",
  "t013": "De productkeuzes konden niet worden geladen.",
  "t014": "Vensterbank {eerste} van {totaal}",
  "t015": "Bevestigen en terug naar het overzicht",
  "t016": "Bevestigen en naar de volgende vensterbank",
  "t017": "Vensterbank bevestigen en verder",
  "t018": "Stap {stap} van {totaal}",
  "t019": "Voortgang",
  "t020": "Product en uitvoering",
  "t021": "Verder met je aanvraag?",
  "t022": "Je eerdere keuzes zijn in dit tabblad bewaard.",
  "t023": "Doorgaan",
  "t024": "Opnieuw beginnen",
  "t025": "Verder naar maten en situatie",
  "t026": "Verder",
  "t027": "Terug",
  "t028": "Verder met je aanvraag",
  "t029": "Start je offerteaanvraag",
  "t030": "Controleer deze gegevens.",
  "t031": "Een voorstel op maat",
  "t032": "st.",
  "t033": "Product nog kiezen",
  "t034": "Afgerond",
  "t035": "Nog afronden",
  "t036": "Laten plaatsen",
  "t037": "Zelf plaatsen",
  "t038": "Hulp bij je aanvraag?",
  "t039": "Je aanvraag is gratis en vrijblijvend. Binnen 3 werkdagen reactie.",
  "t040": "Liever eerst advies?",
  "t041": "Gratis advies aanvragen",
  "t042": "Vraag mijn offerte aan",
  "t043": "Vraag een inmeting aan",
  "t044": "Vraag gratis advies aan",
  "t045": "Vraag een showroomafspraak aan",
  "t046": "Waar kunnen we je bij helpen?",
  "t047": "Heb je al een materiaal in gedachten?",
  "t048": "Ja, ik wil mijn vensterbanken samenstellen",
  "t049": "Kies de collectie, het product en de uitvoering die bij je passen.",
  "t050": "Ik wil eerst advies",
  "t051": "Bespreek je wensen telefonisch, per e-mail of in onze showroom.",
  "t052": "Hoeveel vensterbanken heb je nodig?",
  "t053": "Bijvoorbeeld 4",
  "t054": "Kies jouw vensterbank",
  "t055": "Begin met de eerste vensterbank",
  "t056": "Keuzes van vorige overnemen",
  "t057": "Verwijderen",
  "t058": "Herkenbare naam",
  "t059": "Bijvoorbeeld woonkamer links",
  "t060": "Aantal gelijke vensterbanken",
  "t061": "Zelfde product, uitvoering, maten en werkzaamheden.",
  "t062": "Welke uitvoering zoek je?",
  "t063": "Nieuwe vensterbank",
  "t064": "Op een lege plek of ter vervanging van de bestaande vensterbank.",
  "t065": "Overzetvensterbank",
  "t066": "De nieuwe vensterbank komt over de bestaande vensterbank heen.",
  "t067": "Collectie:",
  "t068": "Andere collectie",
  "t069": "Kies je collectie",
  "t070": "Ander product kiezen",
  "t071": "Kies het product",
  "t072": "Zoek binnen deze collectie",
  "t073": "Zoek op productnaam",
  "t074": "Uitvoering",
  "t075": "Bekijk product",
  "t076": "De productkeuzes worden geladen",
  "t077": "Opnieuw laden",
  "t078": "Er staan {aantal} vensterbanken in je aanvraag.",
  "t079": "Pas het totaal aan naar {aantal}",
  "t080": "De producten worden geladen",
  "t081": "Geen producten gevonden. Pas je zoekopdracht aan of kies een andere collectie.",
  "t082": "Dit product wordt uitgevoerd als",
  "t083": "overzetvensterbank",
  "t084": "Afwerking",
  "t085": "Dikte bovenplaat:",
  "t086": "Dikte:",
  "t087": "Dikte van de bovenplaat",
  "t088": "Dikte",
  "t089": "Gewenste dikte (millimeter)",
  "t090": "Bijvoorbeeld 25",
  "t091": "Beschikbare productbreedte",
  "t092": "Beschikbare productlengte",
  "t093": "Verfmerk",
  "t094": "Verfmerken hebben verschillende prijzen.",
  "t095": "Kleur, verfmerk en glansgraad kies ik later",
  "t096": "Glansgraad",
  "t097": "Glansgraad van de blanke lak",
  "t098": "Gewenste kleur",
  "t099": "Bijvoorbeeld RAL 7016",
  "t100": "Geef de kleurcode of een omschrijving door.",
  "t101": "Zaagsneden naar de opgegeven maten",
  "t102": "Eindkappen meenemen in de offerte",
  "t103": "Kies de olieafwerking",
  "t104": "Kies de kleur",
  "t105": "Olieafwerking wijzigen",
  "t106": "Kleur wijzigen",
  "t107": "Kleur, verfmerk en glansgraad worden later bepaald.",
  "t108": "Nu een kleur kiezen",
  "t109": "Zoek een kleur",
  "t110": "Zoek op naam of kleurcode",
  "t111": "Of geef een andere kleur binnen dit merk door",
  "t112": "Kleurcode of kleurnaam",
  "t113": "Kleuren op je scherm zijn indicatief.",
  "t114": "Geen kleur gevonden. Je kunt hieronder de gewenste kleurcode doorgeven.",
  "t115": "Bekijk alle kleuren van dit merk",
  "t116": "Verfijn je zoekopdracht om de overige kleuren te vinden.",
  "t117": "Kies eerst een vensterbank.",
  "t118": "stuks",
  "t119": "Lengte",
  "t120": "Breedte",
  "t121": "Bovenaanzicht met de lengte over de lange zijde en de breedte over de korte zijde",
  "t122": "Ik vul de maten in",
  "t123": "Centimeters",
  "t124": "Millimeters",
  "t125": "Lengte (geschat) in {eenheid}",
  "t126": "Bijvoorbeeld 120",
  "t127": "Bijvoorbeeld 1200",
  "t128": "Breedte (geschat) in {eenheid}",
  "t129": "Bijvoorbeeld 250",
  "t130": "De bestaande vensterbank blijft zitten.",
  "t131": "Ligt er al een vensterbank?",
  "t132": "Ja, er ligt al een vensterbank",
  "t133": "Nee, het is een lege situatie",
  "t134": "Weet ik nog niet",
  "t135": "Materiaal van de bestaande vensterbank",
  "t136": "Steen of composiet",
  "t137": "Beton",
  "t138": "Tegels",
  "t139": "Hout of MDF",
  "t140": "Kunststof",
  "t141": "Anders",
  "t142": "Weet ik niet",
  "t143": "Zijn er bijzonderheden?",
  "t144": "Je kunt meerdere situaties kiezen.",
  "t145": "Beschrijf de andere situatie",
  "t146": "Welke extra werkzaamheden wil je laten uitvoeren?",
  "t147": "Deze vensterbank laten inmeten",
  "t148": "Extra informatie over deze vensterbank (optioneel)",
  "t149": "Wat mogen wij verzorgen?",
  "t150": "Hoe wil je de definitieve maten bepalen?",
  "t151": "Zelf inmeten",
  "t152": "Ik lever de definitieve maten zelf aan.",
  "t153": "Laten inmeten",
  "t154": "Ik wil de betaalde inmeetservice meenemen in de offerte.",
  "t155": "Ook met ingevulde maten kun je ons laten inmeten.",
  "t156": "Hoe wil je de vensterbanken plaatsen?",
  "t157": "Ik plaats de vensterbanken zelf of regel de plaatsing.",
  "t158": "Ik wil de vensterbanken laten plaatsen.",
  "t159": "Hoe wil je de vensterbanken ontvangen?",
  "t160": "Zelf ophalen",
  "t161": "Op afspraak in Hazerswoude-Dorp.",
  "t162": "Laten afleveren",
  "t163": "Neem de bezorging mee in mijn offerte.",
  "t164": "Wanneer wil je het project ongeveer uitvoeren? (optioneel)",
  "t165": "Bijvoorbeeld eind september",
  "t166": "We bespreken de haalbare planning persoonlijk met je.",
  "t167": "We helpen je graag kiezen.",
  "t168": "Hoe wil je advies ontvangen?",
  "t169": "Telefonisch advies",
  "t170": "Bespreek je wensen en vragen met ons.",
  "t171": "Advies per e-mail",
  "t172": "Ontvang een persoonlijke reactie op je vragen.",
  "t173": "Een bezoek aan de showroom",
  "t174": "Bekijk materialen en afwerkingen op afspraak.",
  "t175": "Waarover wil je advies?",
  "t176": "Materiaal en uitstraling",
  "t177": "Kleur en afwerking",
  "t178": "Inmeten of plaatsen",
  "t179": "Mijn complete project",
  "t180": "Een andere vraag",
  "t181": "Voorkeursdatum of periode (optioneel)",
  "t182": "Bijvoorbeeld een dag of week",
  "t183": "Voorkeur voor dagdeel (optioneel)",
  "t184": "Bijvoorbeeld op een ochtend",
  "t185": "Onze showroom is in Hazerswoude-Dorp en is op afspraak te bezoeken. Je afspraak is definitief nadat we het moment samen hebben bevestigd.",
  "t186": "Hoe kunnen we je bereiken?",
  "t187": "Voor- en achternaam *",
  "t188": "Je naam",
  "t189": "Telefoonnummer *",
  "t190": "Bijvoorbeeld 06 12345678",
  "t191": "E-mailadres *",
  "t192": "naam@voorbeeld.nl",
  "t193": "Straatnaam *",
  "t194": "Straatnaam",
  "t195": "Huisnummer *",
  "t196": "Nummer",
  "t197": "Toevoeging",
  "t198": "Bijvoorbeeld A",
  "t199": "Postcode *",
  "t200": "1234 AB",
  "t201": "Plaats",
  "t202": "Woonplaats of projectlocatie",
  "t203": "Woonplaats",
  "t204": "Extra informatie of een bericht (optioneel)",
  "t205": "Vertel ons bijvoorbeeld iets over je verbouwing, bereikbaarheid of andere wensen.",
  "t206": "Controleer je aanvraag",
  "t207": "Controleer je keuzes voordat je de aanvraag verstuurt.",
  "t208": "Aanpassen",
  "t209": "Aantal",
  "t210": "Nog niet bekend",
  "t211": "Plaatsing",
  "t212": "Inmeten",
  "t213": "Ontvangst",
  "t214": "Uitvoerperiode",
  "t215": "Advies",
  "t216": "Telefonisch",
  "t217": "Per e-mail",
  "t218": "Showroombezoek",
  "t219": "Onderwerp",
  "t220": "Voorkeursmoment",
  "t221": "Nog te bespreken",
  "t222": "Product",
  "t223": "Nog niet gekozen",
  "t224": "Kleur",
  "t225": "Later bepalen",
  "t226": "Olie",
  "t227": "Extra afwerking",
  "t228": "Alleen geschuurd",
  "t229": "Productbreedte",
  "t230": "Productlengte",
  "t231": "Maten",
  "t232": "Nog niet ingevuld",
  "t233": "Bestaande situatie",
  "t234": "De bestaande vensterbank blijft zitten",
  "t235": "Er ligt al een vensterbank",
  "t236": "Lege situatie",
  "t237": "Bestaand materiaal",
  "t238": "Bijzonderheden",
  "t239": "Toelichting situatie",
  "t240": "Werkzaamheden",
  "t241": "Niet aangevraagd",
  "t242": "Zaagsneden",
  "t243": "Meenemen in de offerte",
  "t244": "Eindkappen",
  "t245": "Niet meenemen",
  "t246": "Ja",
  "t247": "Nee",
  "t248": "Toelichting",
  "t249": "Gekozen product bekijken",
  "t250": "Contactgegevens",
  "t251": "Naam",
  "t252": "Telefoon",
  "t253": "E-mail",
  "t254": "Adres",
  "t255": "Postcode en plaats",
  "t256": "Bericht",
  "t257": "Toegevoegde foto’s",
  "t258": "Je aanvraag is gratis en vrijblijvend. We reageren binnen",
  "t259": "3 werkdagen",
  "t260": "om je wensen en de vervolgstappen te bespreken.",
  "t261": "Niet meesturen",
  "t262": "Wacht tot de foto’s klaar zijn met toevoegen.",
  "t263": "Mislukte upload opnieuw starten",
  "t264": "Foto’s toevoegen is op dit moment niet beschikbaar. Je kunt je aanvraag versturen en de foto’s later per e-mail toesturen.",
  "t265": "Je hebt gekozen voor laten inmeten. Vink minimaal één vensterbank aan om te laten inmeten, of pas je keuze bij Diensten aan.",
  "t266": "Wacht tot de foto’s klaar zijn of verwijder de mislukte upload.",
  "t267": "Wacht tot de productkeuzes zijn geladen.",
  "t268": "Het aantal is hoger dan het opgegeven totaal. Pas het aantal van deze vensterbank of het totaal aan.",
  "t269": "De keuzes van de vorige vensterbank zijn overgenomen. Controleer de maten en werkzaamheden.",
  "t270": "Vensterbank verwijderd.",
  "t271": "Ongedaan maken",
  "t272": "Je kunt de foto opnieuw toevoegen.",
  "t273": "Deze foto is groter dan 10 megabyte. Kies een kleinere foto.",
  "t274": "Foto toegevoegd.",
  "t275": "De productkeuzes moeten opnieuw worden geladen.",
  "t276": "Je aanvraag is erg uitgebreid. Neem contact met ons op, zodat we alle gegevens goed kunnen ontvangen.",
  "t277": "De controle van dit voorbeeld is geslaagd.",
  "t278": "Er is geen aanvraag verstuurd.",
  "t279": "Voorbeeld gecontroleerd. Er is geen aanvraag verstuurd.",
  "t280": "Je aanvraag wordt verstuurd…",
  "t281": "Je aanvraag wordt verstuurd.",
  "t282": "Aanvraag",
  "t283": "We bevestigen je showroomafspraak persoonlijk.",
  "t284": "We bespreken eerst de inmeting. De prijs van de vensterbanken volgt na het inmeten.",
  "t285": "Schuine muren of dagkanten",
  "t286": "Hoek, ronding of bocht",
  "t287": "Uitsparing nodig",
  "t288": "Leidingen",
  "t289": "Uitstekende kozijnonderdelen",
  "t290": "Sterk veranderende breedte",
  "t291": "Vensterbanken moeten precies aansluiten",
  "t292": "Vensterbank loopt om een hoek",
  "t293": "Geen bijzonderheden",
  "t294": "Bestaande vensterbank verwijderen",
  "t295": "Oud materiaal afvoeren",
  "t296": "Afkitten",
  "t297": "Ondergrond voorbereiden",
  "t298": "Geef aan of je al een materiaal in gedachten hebt.",
  "t299": "Vul het aantal vensterbanken in, vanaf 1.",
  "t300": "Voeg minimaal één vensterbank toe.",
  "t301": "Kies een nieuwe vensterbank of een overzetvensterbank.",
  "t302": "Kies een collectie en een product.",
  "t303": "Laad de productkeuzes voordat je verdergaat.",
  "t304": "Vul een geldig aantal in.",
  "t305": "Kies de gewenste afwerking.",
  "t306": "Kies de gewenste dikte.",
  "t307": "Kies het verfmerk. Het verfmerk is nodig voor de prijs.",
  "t308": "Kies een kleur of geef aan dat je die later bepaalt.",
  "t309": "Kies de gewenste glansgraad.",
  "t310": "Kies de gewenste olieafwerking.",
  "t311": "Kies de beschikbare productbreedte.",
  "t312": "Kies de beschikbare productlengte.",
  "t313": "Vul de lengte (geschat) in, groter dan 0.",
  "t314": "Vul de breedte (geschat) in, groter dan 0.",
  "t315": "Geef aan of er al een vensterbank ligt.",
  "t316": "Beschrijf de bijzondere situatie.",
  "t317": "Kies zelf plaatsen of laten plaatsen.",
  "t318": "Kies zelf inmeten of laten inmeten.",
  "t319": "Vink bij minimaal één vensterbank de inmeetservice aan of pas je keuze voor inmeten aan.",
  "t320": "Kies ophalen of laten afleveren.",
  "t321": "Kies hoe je advies wilt ontvangen.",
  "t322": "Vertel kort waarover je advies wilt.",
  "t323": "Vul je naam in.",
  "t324": "Vul een telefoonnummer in waarop we je kunnen bereiken.",
  "t325": "Controleer je e-mailadres.",
  "t326": "Vul de woonplaats of projectlocatie in.",
  "t327": "Vul de straatnaam in.",
  "t328": "Vul het huisnummer in.",
  "t329": "Vul de postcode in, bijvoorbeeld 1234 AB.",
  "route_offerte": "Offerteaanvraag",
  "route_inmeten": "Inmeetverzoek",
  "route_advies": "Adviesaanvraag",
  "route_showroom": "Verzoek showroomafspraak",
  "error_thickness": "Vul een dikte van {min} tot {max} millimeter in.",
  "error_variant": "Kies {keuze}.",
  "error_count": "Je aanvraag bevat {aantal} van de {totaal} vensterbanken. Rond de overige vensterbanken af of pas het totaal aan.",
  "aside_count_one": "{aantal} vensterbank",
  "aside_count_many": "{aantal} vensterbanken",
  "unit_cm_label": "centimeters",
  "unit_mm_label": "millimeters",
  "count_optional": "Hoeveel vensterbanken heb je nodig? (optioneel)",
  "bank_position_many": "Vensterbanken {eerste}–{laatste} van {totaal}",
  "removed_sill": "{naam} is verwijderd.",
  "success_one": "{aanvraag} voor {aantal} vensterbank.",
  "success_many": "{aanvraag} voor {aantal} vensterbanken.",
  "success_empty": "{aanvraag}.",
  "error_mdf_overlay": "Voor MDF gespoten als overzetvensterbank wordt Dexter gebruikt. Laad dit product opnieuw.",
  "success_close_hint": "Deze melding sluit automatisch na 5 seconden."
};
  var TEXT_KEYS={
  "Jouw offerteaanvraag": "dialog_title",
  "Offerteaanvraag voor vensterbanken": "dialog_label",
  "Sluit offerteaanvraag": "close_label",
  "Aanvraag ontvangen": "success_badge",
  "Bedankt voor je aanvraag.": "success_title",
  "We bekijken je wensen en nemen binnen 3 werkdagen persoonlijk contact met je op.": "success_body",
  "Nieuwe aanvraag": "restart_label",
  "Je aanvraag is nog niet verstuurd.": "server_error_title",
  "Controleer de melding hieronder. Je eerdere keuzes worden waar mogelijk teruggezet.": "server_error_body",
  "Je aanvraaghulp wordt geladen.": "loading_label",
  "Foto’s van je situatie (optioneel)": "photo_title",
  "Je kunt meerdere foto’s toevoegen.": "photo_hint",
  "Bij welke vensterbank horen de foto’s?": "photo_target",
  "Algemene situatie": "photo_general",
  "Foto’s toevoegen wordt geladen. Je kunt je aanvraag ook zonder foto’s versturen.": "photo_loading",
  "Maximaal 10 megabyte per foto.": "photo_limit",
  "We gebruiken je gegevens om je aanvraag te behandelen en contact met je op te nemen.": "privacy_body",
  "Lees ons privacybeleid": "privacy_link",
  "Jouw project": "t001",
  "Vensterbanken": "t002",
  "Maten en situatie": "t003",
  "Diensten": "t004",
  "Advies of showroom": "t005",
  "Je gegevens": "t006",
  "Controleren": "t007",
  "Maak een keuze": "t008",
  "Jouw aanvraag": "t009",
  "Ongeldige collectie.": "t010",
  "De collectie kon niet worden geladen.": "t011",
  "Deze collectie is te groot om in één keer te openen.": "t012",
  "De productkeuzes konden niet worden geladen.": "t013",
  "Vensterbank {eerste} van {totaal}": "t014",
  "Bevestigen en terug naar het overzicht": "t015",
  "Bevestigen en naar de volgende vensterbank": "t016",
  "Vensterbank bevestigen en verder": "t017",
  "Stap {stap} van {totaal}": "t018",
  "Voortgang": "t019",
  "Product en uitvoering": "t020",
  "Verder met je aanvraag?": "t021",
  "Je eerdere keuzes zijn in dit tabblad bewaard.": "t022",
  "Doorgaan": "t023",
  "Opnieuw beginnen": "t024",
  "Verder naar maten en situatie": "t025",
  "Verder": "t026",
  "Terug": "t027",
  "Verder met je aanvraag": "t028",
  "Start je offerteaanvraag": "t029",
  "Controleer deze gegevens.": "t030",
  "Een voorstel op maat": "t031",
  "st.": "t032",
  "Product nog kiezen": "t033",
  "Afgerond": "t034",
  "Nog afronden": "t035",
  "Laten plaatsen": "t036",
  "Zelf plaatsen": "t037",
  "Hulp bij je aanvraag?": "t038",
  "Je aanvraag is gratis en vrijblijvend. Binnen 3 werkdagen reactie.": "t039",
  "Liever eerst advies?": "t040",
  "Gratis advies aanvragen": "t041",
  "Vraag mijn offerte aan": "t042",
  "Vraag een inmeting aan": "t043",
  "Vraag gratis advies aan": "t044",
  "Vraag een showroomafspraak aan": "t045",
  "Waar kunnen we je bij helpen?": "t046",
  "Heb je al een materiaal in gedachten?": "t047",
  "Ja, ik wil mijn vensterbanken samenstellen": "t048",
  "Kies de collectie, het product en de uitvoering die bij je passen.": "t049",
  "Ik wil eerst advies": "t050",
  "Bespreek je wensen telefonisch, per e-mail of in onze showroom.": "t051",
  "Hoeveel vensterbanken heb je nodig?": "t052",
  "Bijvoorbeeld 4": "t053",
  "Kies jouw vensterbank": "t054",
  "Begin met de eerste vensterbank": "t055",
  "Keuzes van vorige overnemen": "t056",
  "Verwijderen": "t057",
  "Herkenbare naam": "t058",
  "Bijvoorbeeld woonkamer links": "t059",
  "Aantal gelijke vensterbanken": "t060",
  "Zelfde product, uitvoering, maten en werkzaamheden.": "t061",
  "Welke uitvoering zoek je?": "t062",
  "Nieuwe vensterbank": "t063",
  "Op een lege plek of ter vervanging van de bestaande vensterbank.": "t064",
  "Overzetvensterbank": "t065",
  "De nieuwe vensterbank komt over de bestaande vensterbank heen.": "t066",
  "Collectie:": "t067",
  "Andere collectie": "t068",
  "Kies je collectie": "t069",
  "Ander product kiezen": "t070",
  "Kies het product": "t071",
  "Zoek binnen deze collectie": "t072",
  "Zoek op productnaam": "t073",
  "Uitvoering": "t074",
  "Bekijk product": "t075",
  "De productkeuzes worden geladen": "t076",
  "Opnieuw laden": "t077",
  "Er staan {aantal} vensterbanken in je aanvraag.": "t078",
  "Pas het totaal aan naar {aantal}": "t079",
  "De producten worden geladen": "t080",
  "Geen producten gevonden. Pas je zoekopdracht aan of kies een andere collectie.": "t081",
  "Dit product wordt uitgevoerd als": "t082",
  "overzetvensterbank": "t083",
  "Afwerking": "t084",
  "Dikte bovenplaat:": "t085",
  "Dikte:": "t086",
  "Dikte van de bovenplaat": "t087",
  "Dikte": "t088",
  "Gewenste dikte (millimeter)": "t089",
  "Bijvoorbeeld 25": "t090",
  "Beschikbare productbreedte": "t091",
  "Beschikbare productlengte": "t092",
  "Verfmerk": "t093",
  "Verfmerken hebben verschillende prijzen.": "t094",
  "Kleur, verfmerk en glansgraad kies ik later": "t095",
  "Glansgraad": "t096",
  "Glansgraad van de blanke lak": "t097",
  "Gewenste kleur": "t098",
  "Bijvoorbeeld RAL 7016": "t099",
  "Geef de kleurcode of een omschrijving door.": "t100",
  "Zaagsneden naar de opgegeven maten": "t101",
  "Eindkappen meenemen in de offerte": "t102",
  "Kies de olieafwerking": "t103",
  "Kies de kleur": "t104",
  "Olieafwerking wijzigen": "t105",
  "Kleur wijzigen": "t106",
  "Kleur, verfmerk en glansgraad worden later bepaald.": "t107",
  "Nu een kleur kiezen": "t108",
  "Zoek een kleur": "t109",
  "Zoek op naam of kleurcode": "t110",
  "Of geef een andere kleur binnen dit merk door": "t111",
  "Kleurcode of kleurnaam": "t112",
  "Kleuren op je scherm zijn indicatief.": "t113",
  "Geen kleur gevonden. Je kunt hieronder de gewenste kleurcode doorgeven.": "t114",
  "Bekijk alle kleuren van dit merk": "t115",
  "Verfijn je zoekopdracht om de overige kleuren te vinden.": "t116",
  "Kies eerst een vensterbank.": "t117",
  "stuks": "t118",
  "Lengte": "t119",
  "Breedte": "t120",
  "Bovenaanzicht met de lengte over de lange zijde en de breedte over de korte zijde": "t121",
  "Ik vul de maten in": "t122",
  "Centimeters": "t123",
  "Millimeters": "t124",
  "Lengte (geschat) in {eenheid}": "t125",
  "Bijvoorbeeld 120": "t126",
  "Bijvoorbeeld 1200": "t127",
  "Breedte (geschat) in {eenheid}": "t128",
  "Bijvoorbeeld 250": "t129",
  "De bestaande vensterbank blijft zitten.": "t130",
  "Ligt er al een vensterbank?": "t131",
  "Ja, er ligt al een vensterbank": "t132",
  "Nee, het is een lege situatie": "t133",
  "Weet ik nog niet": "t134",
  "Materiaal van de bestaande vensterbank": "t135",
  "Steen of composiet": "t136",
  "Beton": "t137",
  "Tegels": "t138",
  "Hout of MDF": "t139",
  "Kunststof": "t140",
  "Anders": "t141",
  "Weet ik niet": "t142",
  "Zijn er bijzonderheden?": "t143",
  "Je kunt meerdere situaties kiezen.": "t144",
  "Beschrijf de andere situatie": "t145",
  "Welke extra werkzaamheden wil je laten uitvoeren?": "t146",
  "Deze vensterbank laten inmeten": "t147",
  "Extra informatie over deze vensterbank (optioneel)": "t148",
  "Wat mogen wij verzorgen?": "t149",
  "Hoe wil je de definitieve maten bepalen?": "t150",
  "Zelf inmeten": "t151",
  "Ik lever de definitieve maten zelf aan.": "t152",
  "Laten inmeten": "t153",
  "Ik wil de betaalde inmeetservice meenemen in de offerte.": "t154",
  "Ook met ingevulde maten kun je ons laten inmeten.": "t155",
  "Hoe wil je de vensterbanken plaatsen?": "t156",
  "Ik plaats de vensterbanken zelf of regel de plaatsing.": "t157",
  "Ik wil de vensterbanken laten plaatsen.": "t158",
  "Hoe wil je de vensterbanken ontvangen?": "t159",
  "Zelf ophalen": "t160",
  "Op afspraak in Hazerswoude-Dorp.": "t161",
  "Laten afleveren": "t162",
  "Neem de bezorging mee in mijn offerte.": "t163",
  "Wanneer wil je het project ongeveer uitvoeren? (optioneel)": "t164",
  "Bijvoorbeeld eind september": "t165",
  "We bespreken de haalbare planning persoonlijk met je.": "t166",
  "We helpen je graag kiezen.": "t167",
  "Hoe wil je advies ontvangen?": "t168",
  "Telefonisch advies": "t169",
  "Bespreek je wensen en vragen met ons.": "t170",
  "Advies per e-mail": "t171",
  "Ontvang een persoonlijke reactie op je vragen.": "t172",
  "Een bezoek aan de showroom": "t173",
  "Bekijk materialen en afwerkingen op afspraak.": "t174",
  "Waarover wil je advies?": "t175",
  "Materiaal en uitstraling": "t176",
  "Kleur en afwerking": "t177",
  "Inmeten of plaatsen": "t178",
  "Mijn complete project": "t179",
  "Een andere vraag": "t180",
  "Voorkeursdatum of periode (optioneel)": "t181",
  "Bijvoorbeeld een dag of week": "t182",
  "Voorkeur voor dagdeel (optioneel)": "t183",
  "Bijvoorbeeld op een ochtend": "t184",
  "Onze showroom is in Hazerswoude-Dorp en is op afspraak te bezoeken. Je afspraak is definitief nadat we het moment samen hebben bevestigd.": "t185",
  "Hoe kunnen we je bereiken?": "t186",
  "Voor- en achternaam *": "t187",
  "Je naam": "t188",
  "Telefoonnummer *": "t189",
  "Bijvoorbeeld 06 12345678": "t190",
  "E-mailadres *": "t191",
  "naam@voorbeeld.nl": "t192",
  "Straatnaam *": "t193",
  "Straatnaam": "t194",
  "Huisnummer *": "t195",
  "Nummer": "t196",
  "Toevoeging": "t197",
  "Bijvoorbeeld A": "t198",
  "Postcode *": "t199",
  "1234 AB": "t200",
  "Plaats": "t201",
  "Woonplaats of projectlocatie": "t202",
  "Woonplaats": "t203",
  "Extra informatie of een bericht (optioneel)": "t204",
  "Vertel ons bijvoorbeeld iets over je verbouwing, bereikbaarheid of andere wensen.": "t205",
  "Controleer je aanvraag": "t206",
  "Controleer je keuzes voordat je de aanvraag verstuurt.": "t207",
  "Aanpassen": "t208",
  "Aantal": "t209",
  "Nog niet bekend": "t210",
  "Plaatsing": "t211",
  "Inmeten": "t212",
  "Ontvangst": "t213",
  "Uitvoerperiode": "t214",
  "Advies": "t215",
  "Telefonisch": "t216",
  "Per e-mail": "t217",
  "Showroombezoek": "t218",
  "Onderwerp": "t219",
  "Voorkeursmoment": "t220",
  "Nog te bespreken": "t221",
  "Product": "t222",
  "Nog niet gekozen": "t223",
  "Kleur": "t224",
  "Later bepalen": "t225",
  "Olie": "t226",
  "Extra afwerking": "t227",
  "Alleen geschuurd": "t228",
  "Productbreedte": "t229",
  "Productlengte": "t230",
  "Maten": "t231",
  "Nog niet ingevuld": "t232",
  "Bestaande situatie": "t233",
  "De bestaande vensterbank blijft zitten": "t234",
  "Er ligt al een vensterbank": "t235",
  "Lege situatie": "t236",
  "Bestaand materiaal": "t237",
  "Bijzonderheden": "t238",
  "Toelichting situatie": "t239",
  "Werkzaamheden": "t240",
  "Niet aangevraagd": "t241",
  "Zaagsneden": "t242",
  "Meenemen in de offerte": "t243",
  "Eindkappen": "t244",
  "Niet meenemen": "t245",
  "Ja": "t246",
  "Nee": "t247",
  "Toelichting": "t248",
  "Gekozen product bekijken": "t249",
  "Contactgegevens": "t250",
  "Naam": "t251",
  "Telefoon": "t252",
  "E-mail": "t253",
  "Adres": "t254",
  "Postcode en plaats": "t255",
  "Bericht": "t256",
  "Toegevoegde foto’s": "t257",
  "Je aanvraag is gratis en vrijblijvend. We reageren binnen": "t258",
  "3 werkdagen": "t259",
  "om je wensen en de vervolgstappen te bespreken.": "t260",
  "Niet meesturen": "t261",
  "Wacht tot de foto’s klaar zijn met toevoegen.": "t262",
  "Mislukte upload opnieuw starten": "t263",
  "Foto’s toevoegen is op dit moment niet beschikbaar. Je kunt je aanvraag versturen en de foto’s later per e-mail toesturen.": "t264",
  "Je hebt gekozen voor laten inmeten. Vink minimaal één vensterbank aan om te laten inmeten, of pas je keuze bij Diensten aan.": "t265",
  "Wacht tot de foto’s klaar zijn of verwijder de mislukte upload.": "t266",
  "Wacht tot de productkeuzes zijn geladen.": "t267",
  "Het aantal is hoger dan het opgegeven totaal. Pas het aantal van deze vensterbank of het totaal aan.": "t268",
  "De keuzes van de vorige vensterbank zijn overgenomen. Controleer de maten en werkzaamheden.": "t269",
  "Vensterbank verwijderd.": "t270",
  "Ongedaan maken": "t271",
  "Je kunt de foto opnieuw toevoegen.": "t272",
  "Deze foto is groter dan 10 megabyte. Kies een kleinere foto.": "t273",
  "Foto toegevoegd.": "t274",
  "De productkeuzes moeten opnieuw worden geladen.": "t275",
  "Je aanvraag is erg uitgebreid. Neem contact met ons op, zodat we alle gegevens goed kunnen ontvangen.": "t276",
  "De controle van dit voorbeeld is geslaagd.": "t277",
  "Er is geen aanvraag verstuurd.": "t278",
  "Voorbeeld gecontroleerd. Er is geen aanvraag verstuurd.": "t279",
  "Je aanvraag wordt verstuurd…": "t280",
  "Je aanvraag wordt verstuurd.": "t281",
  "Aanvraag": "t282",
  "We bevestigen je showroomafspraak persoonlijk.": "t283",
  "We bespreken eerst de inmeting. De prijs van de vensterbanken volgt na het inmeten.": "t284",
  "Schuine muren of dagkanten": "t285",
  "Hoek, ronding of bocht": "t286",
  "Uitsparing nodig": "t287",
  "Leidingen": "t288",
  "Uitstekende kozijnonderdelen": "t289",
  "Sterk veranderende breedte": "t290",
  "Vensterbanken moeten precies aansluiten": "t291",
  "Vensterbank loopt om een hoek": "t292",
  "Geen bijzonderheden": "t293",
  "Bestaande vensterbank verwijderen": "t294",
  "Oud materiaal afvoeren": "t295",
  "Afkitten": "t296",
  "Ondergrond voorbereiden": "t297",
  "Geef aan of je al een materiaal in gedachten hebt.": "t298",
  "Vul het aantal vensterbanken in, vanaf 1.": "t299",
  "Voeg minimaal één vensterbank toe.": "t300",
  "Kies een nieuwe vensterbank of een overzetvensterbank.": "t301",
  "Kies een collectie en een product.": "t302",
  "Laad de productkeuzes voordat je verdergaat.": "t303",
  "Vul een geldig aantal in.": "t304",
  "Kies de gewenste afwerking.": "t305",
  "Kies de gewenste dikte.": "t306",
  "Kies het verfmerk. Het verfmerk is nodig voor de prijs.": "t307",
  "Kies een kleur of geef aan dat je die later bepaalt.": "t308",
  "Kies de gewenste glansgraad.": "t309",
  "Kies de gewenste olieafwerking.": "t310",
  "Kies de beschikbare productbreedte.": "t311",
  "Kies de beschikbare productlengte.": "t312",
  "Vul de lengte (geschat) in, groter dan 0.": "t313",
  "Vul de breedte (geschat) in, groter dan 0.": "t314",
  "Geef aan of er al een vensterbank ligt.": "t315",
  "Beschrijf de bijzondere situatie.": "t316",
  "Kies zelf plaatsen of laten plaatsen.": "t317",
  "Kies zelf inmeten of laten inmeten.": "t318",
  "Vink bij minimaal één vensterbank de inmeetservice aan of pas je keuze voor inmeten aan.": "t319",
  "Kies ophalen of laten afleveren.": "t320",
  "Kies hoe je advies wilt ontvangen.": "t321",
  "Vertel kort waarover je advies wilt.": "t322",
  "Vul je naam in.": "t323",
  "Vul een telefoonnummer in waarop we je kunnen bereiken.": "t324",
  "Controleer je e-mailadres.": "t325",
  "Vul de woonplaats of projectlocatie in.": "t326",
  "Vul de straatnaam in.": "t327",
  "Vul het huisnummer in.": "t328",
  "Vul de postcode in, bijvoorbeeld 1234 AB.": "t329",
  "Offerteaanvraag": "route_offerte",
  "Inmeetverzoek": "route_inmeten",
  "Adviesaanvraag": "route_advies",
  "Verzoek showroomafspraak": "route_showroom",
  "Vul een dikte van {min} tot {max} millimeter in.": "error_thickness",
  "Kies {keuze}.": "error_variant",
  "Je aanvraag bevat {aantal} van de {totaal} vensterbanken. Rond de overige vensterbanken af of pas het totaal aan.": "error_count",
  "{aantal} vensterbank": "aside_count_one",
  "{aantal} vensterbanken": "aside_count_many",
  "centimeters": "unit_cm_label",
  "millimeters": "unit_mm_label",
  "Hoeveel vensterbanken heb je nodig? (optioneel)": "count_optional",
  "Vensterbanken {eerste}–{laatste} van {totaal}": "bank_position_many",
  "{naam} is verwijderd.": "removed_sill",
  "{aanvraag} voor {aantal} vensterbank.": "success_one",
  "{aanvraag} voor {aantal} vensterbanken.": "success_many",
  "{aanvraag}.": "success_empty",
  "Voor MDF gespoten als overzetvensterbank wordt Dexter gebruikt. Laad dit product opnieuw.": "error_mdf_overlay",
  "Deze melding sluit automatisch na 5 seconden.": "success_close_hint"
};
  var LEGACY_TEXT_DEFAULTS={t095:'De exacte kleur bepaal ik later',t107:'De exacte kleur bepaal je later binnen het gekozen verfmerk.',t225:'Later bepalen binnen het gekozen verfmerk'};
  function copyDefault(value){var key=TEXT_KEYS[value];return key?'__VBM_TEXT_'+key+'__':value;}
  Quote.prototype.text=function(key,values){
    var value=this.config.texts&&this.config.texts[key];
    if(LEGACY_TEXT_DEFAULTS[key]&&value===LEGACY_TEXT_DEFAULTS[key])value=TEXT_DEFAULTS[key];
    if(typeof value!=='string'||!value.trim())value=TEXT_DEFAULTS[key]||'';
    return value.replace(/\{([a-z]+)\}/g,function(all,name){return values&&Object.prototype.hasOwnProperty.call(values,name)&&values[name]!=null?String(values[name]):all;});
  };
  Quote.prototype.resolveText=function(value){
    var self=this;return String(value==null?'':value).replace(/__VBM_TEXT_([a-z0-9_]+)__/g,function(all,key){return self.text(key);});
  };
  Quote.prototype.renderCopy=function(value){
    var self=this;return String(value==null?'':value).replace(/__VBM_TEXT_([a-z0-9_]+)__/g,function(all,key){return E(self.text(key));});
  };
  Quote.prototype.errorText=function(error){
    var key=TEXT_KEYS[error.message];if(key)return this.text(key);
    if(error.field==='count')return this.text('error_count',{aantal:C.count(this.state),totaal:this.state.expectedCount});
    if(error.field&&error.field.indexOf('variant:')===0)return this.text('error_variant',{keuze:error.field.slice(8).toLowerCase()});
    var b=this.bank(error.bankId);if(error.field==='thickness'&&b&&b.spec&&b.spec.freeThickness&&error.message.indexOf('Vul een dikte van ')===0)return this.text('error_thickness',b.spec.freeThickness);
    return this.resolveText(error.message);
  };

  Quote.prototype.save=function(){this.state.updatedAt=Date.now();if(!this.ui.resume){if(hasRequestContent(this.state))safeWrite(this.key,this.state);else safeRemove(this.key);}};
  Quote.prototype.bank=function(id){return this.state.banks.find(function(b){return b.id===(id||this.ui.active);},this);};
  Quote.prototype.announce=function(message){this.root.querySelector('[data-quote-live]').textContent=this.resolveText(message);};
  Quote.prototype.setupDialog=function(){
    var self=this;this.dialog=this.root.querySelector('[data-quote-dialog]');this.scroll=this.root.querySelector('[data-dialog-scroll]');this.opener=this.root.querySelector('[data-quote-open]');
    if(this.opener)this.opener.addEventListener('click',function(){self.open();});
    this.root.querySelector('[data-quote-close]').addEventListener('click',function(){self.close();});
    this.dialog.addEventListener('close',function(){self.cancelRestart(false);self.cancelSuccessTimer();if(self.ui.showingSuccess)self.ui.successDismissed=true;else if(self.content)self.save();document.body.style.overflow=self.previousOverflow||'';if(self.opener&&document.contains(self.opener))self.opener.focus({preventScroll:true});});
    this.dialog.addEventListener('cancel',function(event){if(self.ui.restartConfirm){event.preventDefault();self.cancelRestart(true);}});
    this.dialog.addEventListener('click',function(event){if(event.target!==self.dialog)return;var r=self.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)self.close();});
    document.addEventListener('shopify:section:unload',function(event){if(event.target.contains(self.root)&&self.dialog.open){if(self.config.designMode)editorReopen=true;self.close();}if(event.target.contains(self.root)&&self.uploadObserver)self.uploadObserver.disconnect();});
  };
  Quote.prototype.open=function(context){
    if(this.dialog.open)return;
    if(this.ui.successDismissed)this.resetSuccess();
    var prior=this.ui.resume||this.state,hasDraft=!!(prior.materialKnown||prior.expectedCount||prior.banks.length||Object.values(prior.contact||{}).some(function(v){return !!v;}));
    if(this.ui.resume){this.state=this.ui.resume;this.ui.resume=null;this.ui.active=(this.state.banks.find(function(b){return !b.confirmed;})||this.state.banks[0]||{}).id||null;this.render();this.refreshRestored();this.save();}
    this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';
    this.dialog.showModal();
    if(this.config.globalPopup&&this.content&&!this.ui.showingSuccess){
      if(!this.colors&&!this.colorLoadRequested){this.colorLoadRequested=true;this.loadColors();}
      if(!hasDraft&&context){this.state.source=location.origin+location.pathname;this.applyPrefill(context);}
    }
    if(this.content&&!this.ui.showingSuccess)this.focus();
    if(this.photoPanel&&!this.photoPanel.hidden)this.ensureUploader();
  };
  Quote.prototype.close=function(){if(this.dialog.open)this.dialog.close();};
  Quote.prototype.cancelSuccessTimer=function(){if(this.successTimer!=null){window.clearTimeout(this.successTimer);this.successTimer=null;}};
  Quote.prototype.updateRestartControls=function(){
    var trigger=this.root.querySelector('[data-quote-restart]'),panel=this.root.querySelector('[data-restart-confirmation]');
    if(trigger){trigger.disabled=!!this.ui.submitting;trigger.setAttribute('aria-expanded',this.ui.restartConfirm?'true':'false');}
    if(panel)panel.hidden=!this.ui.restartConfirm;
    if(this.scroll)this.scroll.inert=!!this.ui.restartConfirm;
  };
  Quote.prototype.requestRestart=function(){
    if(this.ui.submitting)return;
    if(this.ui.showingSuccess||!hasRequestContent(this.ui.resume||this.state)){this.startOver();return;}
    this.ui.restartConfirm=true;this.updateRestartControls();
    var cancel=this.root.querySelector('[data-action="restart-cancel"]');if(cancel)cancel.focus({preventScroll:true});
  };
  Quote.prototype.cancelRestart=function(returnFocus){
    this.ui.restartConfirm=false;this.updateRestartControls();
    var trigger=this.root.querySelector('[data-quote-restart]');if(returnFocus&&trigger)trigger.focus({preventScroll:true});
  };
  Quote.prototype.startOver=function(focus){
    if(this.ui.submitting)return;
    var token=this.ui.navigationToken+1;this.cancelSuccessTimer();this.undo=null;
    this.state=C.initial();this.state.source=location.origin+location.pathname;this.ui=initialUI(token);
    var success=this.root.querySelector('[data-quote-success]');if(success)success.hidden=true;
    var fields=this.root.querySelector('[data-quote-fields]');if(fields)fields.hidden=false;
    var error=this.root.querySelector('[data-shopify-error]');if(error)error.hidden=true;
    if(this.aside){this.aside.hidden=false;this.aside.parentElement.classList.remove('is-success');}
    if(this.form){
      Array.from(this.form.querySelectorAll('[data-post]')).forEach(function(el){el.value='';});
      var mailFields=this.form.querySelector('[data-quote-mail-fields]');if(mailFields)mailFields.replaceChildren();
      Array.from(this.form.querySelectorAll('input[name^="contact["]')).forEach(function(el){if(!el.hasAttribute('data-post'))el.remove();});
      var returnField=this.form.querySelector('input[name="return_to"]');if(returnField)returnField.value=location.pathname;
    }
    if(this.upload){
      if(this.uploadObserver)this.uploadObserver.disconnect();
      var upload=document.createElement('div');upload.className='upload-lift vbm-quote-upload';upload.setAttribute('data-vbm-uploader','');this.upload.replaceWith(upload);this.upload=upload;
      if(this.uploadObserver)this.uploadObserver.observe(upload,{childList:true,subtree:true});
    }
    safeRemove(this.key);safeRemove(this.pendingKey);
    try{for(var i=sessionStorage.length-1;i>=0;i--){var key=sessionStorage.key(i);if(key&&key.startsWith('vbm-quote-v1:')&&!/:done$/.test(key))safeRemove(key);}}catch(e){}
    try{var url=new URL(location.href);url.searchParams.delete('vbm_quote_receipt');url.searchParams.delete('contact_posted');if(url.hash==='#'+this.config.formId)url.hash='';if(window.history&&window.history.replaceState)window.history.replaceState(window.history.state,'',url.pathname+url.search+url.hash);}catch(e){}
    if(!this.colors&&!this.colorLoadRequested){this.colorLoadRequested=true;this.loadColors();}
    this.updateRestartControls();this.render();this.photoAvailability();this.announce(this.text('reset_notice'));
    if(focus!==false&&this.dialog.open)this.focus();
  };
  Quote.prototype.resetSuccess=function(){this.startOver(false);};
  Quote.prototype.jumpTo=function(target){
    if(!target||!this.dialog.open)return;
    target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
    var top=target.getBoundingClientRect().top-this.scroll.getBoundingClientRect().top+this.scroll.scrollTop-16;
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.scroll.scrollTo({top:Math.max(0,top),behavior:reduced?'instant':'smooth'});
  };
  Quote.prototype.nextQuestion=function(key,bankId){
    var questions=Array.from(this.content.querySelectorAll('[data-question]')).filter(function(el){return !el.parentElement.closest('[data-question]');});
    var index=questions.findIndex(function(el){return el.dataset.question===key&&(!bankId||!el.dataset.questionBank||el.dataset.questionBank===bankId);});
    if(index<0)return;
    this.jumpTo(questions[index+1]||(!this.photoPanel.hidden?this.photoPanel:this.actions));
  };
  Quote.prototype.focus=function(){
    var title=this.content.querySelector('h2');if(!title)return;
    this.jumpTo(this.ui.errors.length?this.root.querySelector('[data-errors]'):title);
  };
  Quote.prototype.loadColors=async function(){
    if(this.config.inlineColors){this.colors=this.config.inlineColors;return;}
    try{var res=await fetch(this.config.colorsUrl,{credentials:'same-origin'});if(!res.ok)throw new Error();this.colors=await res.json();if(this.state.step==='vensterbanken')this.render();}
    catch(e){this.colors=null;}
  };
  Quote.prototype.catalog=async function(handle,retry){
    var self=this;
    if(!/^[a-z0-9-]+$/.test(handle))throw new Error("__VBM_TEXT_t010__");
    if(retry)this.catalogs.delete(handle);
    if(this.catalogs.has(handle))return this.catalogs.get(handle);
    var promise=(async function(){
      var material=self.config.materials.find(function(m){return m.handle===handle;});
      if(material&&material.requestOnly)return [{id:'kunststof-overzet-op-aanvraag',handle:'kunststof-overzet-op-aanvraag',title:'Kunststof overzet op aanvraag',type:'vensterbank',requestOnly:true,url:new URL(self.config.rootUrl+'pages/overzetvensterbanken',self.config.shopUrl).href,image:material.image,variants:[]}];
      if(self.config.inlineCatalogs&&self.config.inlineCatalogs[handle])return self.config.inlineCatalogs[handle];
      if(self.config.fixtureBase){
        var fixture=await fetch(self.config.fixtureBase+'/catalog-'+handle+'.json');if(!fixture.ok)throw new Error("__VBM_TEXT_t011__");return fixture.json();
      }
      var products=[],page=1,pages=1;
      do{
        var url=new URL(self.config.rootUrl+'collections/'+handle,location.origin);url.searchParams.set('section_id',self.config.catalogSection);url.searchParams.set('page',String(page));
        var response=await fetch(url.href,{credentials:'same-origin',headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error("__VBM_TEXT_t011__");
        var html=await response.text();var parsed=new DOMParser().parseFromString(html,'text/html');
        var script=parsed.querySelector('[data-vbm-catalog]');if(!script)throw new Error("__VBM_TEXT_t011__");
        var data=JSON.parse(script.textContent);if(data.error||!Array.isArray(data.products)||data.handle&&data.handle!==handle)throw new Error("__VBM_TEXT_t011__");
        products=products.concat(data.products);pages=Math.max(1,Number(data.pages)||1);page++;
        if(page>30&&page<=pages)throw new Error("__VBM_TEXT_t012__");
      }while(page<=pages);
      return products;
    })();
    this.catalogs.set(handle,promise);
    try{return await promise;}catch(e){if(this.catalogs.get(handle)===promise)this.catalogs.delete(handle);throw e;}
  };
  Quote.prototype.getSpec=async function(product,retry){
    if(retry)this.productSpecs.delete(product.handle);
    if(this.productSpecs.has(product.handle))return this.productSpecs.get(product.handle);
    var self=this;
    var promise=(async function(){
      if(product.requestOnly)return {finishes:[],thicknesses:[{value:'3',label:'3 millimeter'}],freeThickness:null,brands:[],paintGloss:[],woodGloss:[],sanding:[],rubio:false,aluminium:false,sawing:false,endcaps:false,widths:[],lengths:[],stockLength:'',variants:[{name:'Kleur of uitstraling',values:['Wit','Crème','Marmerlook','Blauwsteenlook'].map(function(v){return {value:v,label:v};})}]};
      if(self.config.inlineSpecs&&self.config.inlineSpecs[product.handle])return self.config.inlineSpecs[product.handle];
      var url=self.config.fixtureBase?self.config.fixtureBase+'/product-'+product.handle+'.html':new URL(product.url,self.config.shopUrl||location.origin).pathname;
      var response=await fetch(url,{credentials:'same-origin',headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error("__VBM_TEXT_t013__");
      var html=await response.text();
      try{return C.parseProductHTML(html,DOMParser);}
      catch(error){var fallback=error.code==='missing_product_options'&&C.productFallback(product.handle);if(fallback)return fallback;throw error;}
    })();
    this.productSpecs.set(product.handle,promise);
    try{return await promise;}catch(e){if(this.productSpecs.get(product.handle)===promise)this.productSpecs.delete(product.handle);throw e;}
  };
  Quote.prototype.selectMaterial=async function(b,handle,retry){
    if(!b)return;
    var request=this.state,token=++this.ui.navigationToken,step=this.state.step;b.confirmed=false;
    var required=C.requiredProduct({type:b.type,material:handle});
    if(b.material!==handle||required&&b.product&&b.product.handle!==required){b.material=handle;b.product=null;b.spec=null;b.finish='';b.thickness='';b.color=null;b.colorLater=false;b.brand='';b.gloss='';b.variants={};b.endcap=false;}
    this.ui.showMaterials=false;this.ui.showProductPicker=!required;this.ui.productSearch='';this.ui.loading='catalog:'+b.id;this.ui.catalogError=null;this.render();
    this.nextQuestion('material',b.id);
    var loading=this.catalog(handle,retry),entry=this.catalogs.get(handle);
    try{var products=await loading;if(required&&token===this.ui.navigationToken&&this.ui.active===b.id&&this.state.step===step&&C.requiredProduct(b)===required){if(!products.some(function(p){return p.handle===required;}))throw new Error('__VBM_TEXT_error_mdf_overlay__');await this.selectProduct(b,required);}}
    catch(e){if(this.state===request&&b.material===handle&&(!this.catalogs.has(handle)||this.catalogs.get(handle)===entry)&&this.ui.active===b.id)this.ui.catalogError=e.message;}
    finally{if(this.state!==request||b.material!==handle||this.catalogs.has(handle)&&this.catalogs.get(handle)!==entry)return;if(this.ui.loading==='catalog:'+b.id)this.ui.loading=null;this.render();this.save();if(token===this.ui.navigationToken&&this.ui.active===b.id&&this.state.step===step)this.nextQuestion('material',b.id);}
  };
  Quote.prototype.selectProduct=async function(b,handle,retry){
    if(!b)return;
    var request=this.state,token=++this.ui.navigationToken,step=this.state.step;b.confirmed=false;
    handle=C.requiredProduct(b)||handle;
    var products=await this.catalog(b.material);if(this.state!==request)return;var product=products.find(function(p){return p.handle===handle;});
    if(!product)return;
    this.assignProduct(b,product);
    this.ui.showProductPicker=false;this.ui.loading='product:'+b.id;this.ui.productError=null;this.render();
    try{var spec=await this.getSpec(product,retry);if(this.state===request&&b.product&&b.product.handle===handle)C.applySpec(b,spec);}
    catch(e){if(this.state===request)this.ui.productError=e.message;}
    finally{if(this.state!==request)return;if(this.ui.loading==='product:'+b.id)this.ui.loading=null;this.render();this.save();if(token===this.ui.navigationToken&&this.ui.active===b.id&&this.state.step===step)this.nextQuestion('product',b.id);}
  };
  Quote.prototype.assignProduct=function(b,product){
    if(!b.product||b.product.id!==product.id||b.product.handle!==product.handle){b.product=product;b.spec=null;b.finish='';b.thickness='';b.brand='';b.color=null;b.colorLater=false;b.gloss='';b.rubio=null;b.sanding=false;b.stockWidth='';b.stockLength='';b.variants={};b.endcap=false;b.confirmed=false;}
  };
  Quote.prototype.materials=function(b){return this.config.materials.filter(function(m){return m.handle&&(b.type==='overzet'?m.overzet:m.normal);});};
  Quote.prototype.products=function(b){
    var promise=this.catalogs.get(b.material);
    if(!promise||!promise.resolved)return [];
    var required=C.requiredProduct(b);return promise.resolved.filter(function(p){return (!required||p.handle===required)&&!/eindkap/i.test(p.type||'')&&!/aangepaste prijs|custom price/i.test(p.title);});
  };
  Quote.prototype.addBank=function(copy){
    var b=copy?JSON.parse(JSON.stringify(copy)):C.bank(this.state.banks.length+1);
    if(copy){b.id=C.uid();b.name='Vensterbank '+(this.state.banks.length+1);b.quantity=1;}
    b.confirmed=false;this.state.banks.push(b);this.ui.active=b.id;this.ui.productSearch='';this.ui.showMaterials=false;this.ui.showProductPicker=false;this.ui.colorPickerOpen=false;this.ui.errors=[];this.render();this.save();
  };
  Quote.prototype.bankPosition=function(){
    var b=this.bank(),first=1;for(var item of this.state.banks){if(item===b)break;first+=Number(item.quantity)||0;}
    var last=first+(b?Number(b.quantity)||1:1)-1;
    return this.text(last>first?'bank_position_many':"t014",{eerste:first,laatste:last,totaal:this.state.expectedCount});
  };
  Quote.prototype.confirmLabel=function(){
    var b=this.bank(),index=this.state.banks.indexOf(b),next=this.state.banks[index+1];
    if(this.ui.returnToReview&&C.count(this.state)===Number(this.state.expectedCount)&&this.state.banks.every(function(item){return item===b||item.confirmed;}))return "__VBM_TEXT_t015__";
    if(next||C.count(this.state)<Number(this.state.expectedCount))return "__VBM_TEXT_t016__";
    return this.ui.returnToReview?"__VBM_TEXT_t015__":"__VBM_TEXT_t017__";
  };
  Quote.prototype.progress=function(){
    var s=this.state.materialKnown==='no'?C.steps(this.state):['project','diensten','vensterbanken','gegevens','controle'];
    var current=this.state.step==='maten'?'vensterbanken':this.state.step,index=s.indexOf(current);
    this.root.querySelector('[data-progress]').innerHTML=this.renderCopy('<p class="q-step-label-mobile">'+E(this.text("t018",{stap:index+1,totaal:s.length}))+' · '+E(LABELS[current])+'</p><ol class="q-steps" aria-label="'+E(this.text("t019"))+'">'+s.map(function(name,i){return '<li class="q-step '+(i===index?'is-current':i<index?'is-done':'')+'"'+(i===index?' aria-current="step"':'')+'>'+E(LABELS[name])+'</li>';}).join('')+'</ol>'+(['vensterbanken','maten'].includes(this.state.step)&&this.bank()?'<p class="q-bank-progress">'+E(this.bankPosition())+' · '+(this.state.step==='vensterbanken'?'__VBM_TEXT_t020__':LABELS.maten)+'</p>':''));
  };
  Quote.prototype.render=function(){
    this.updateRestartControls();
    if(!this.content||this.ui.submitting)return;
    var active=document.activeElement,focusKey=active&&this.content.contains(active)?{id:active.id,tag:active.tagName,name:active.name,value:active.value,action:active.dataset.action,b:active.dataset.b,s:active.dataset.s,bank:active.dataset.bank,variant:active.dataset.variant,special:active.dataset.special,service:active.dataset.service}:null;
    if(!C.steps(this.state).includes(this.state.step))this.state.step='project';
    this.progress();
    var resume=this.root.querySelector('[data-resume]');
    resume.innerHTML=this.renderCopy(this.ui.resume?"<div class=\"q-restore\"><h3>__VBM_TEXT_t021__</h3><p>__VBM_TEXT_t022__</p>"+button("__VBM_TEXT_t023__",'resume',false)+' '+link("__VBM_TEXT_t024__",'restart')+'</div>':'');
    this.content.innerHTML=this.renderCopy(this['view_'+this.state.step]());
    var list=C.steps(this.state),index=list.indexOf(this.state.step),last=this.state.step==='controle';
    var nextLabel=this.state.step==='maten'?this.confirmLabel():this.state.step==='vensterbanken'?"__VBM_TEXT_t025__":"__VBM_TEXT_t026__";
    this.actions.innerHTML=this.renderCopy((index?button("__VBM_TEXT_t027__",'previous',true):'<span></span>')+'<div class="q-actions__right">'+(last?'<button type="submit" class="q-button" data-send>'+E(this.submitLabel())+' <span aria-hidden="true">→</span></button>':button(nextLabel,'next',false))+'</div>');
    this.renderErrors();this.renderAside();this.renderPhotos();
    if(this.opener&&!this.config.globalPopup)this.opener.innerHTML=this.renderCopy((this.ui.resume||this.state.materialKnown?"__VBM_TEXT_t028__":"__VBM_TEXT_t029__")+' <span aria-hidden="true">→</span>');
    if(this.state.step==='vensterbanken'){
      var b=this.bank();if(b&&b.material&&!this.ui.loading)this.fillProducts();
    }
    if(focusKey){
      var candidates=Array.from(this.content.querySelectorAll('input,select,textarea,button,a'));
      var replacement=candidates.find(function(el){
        if(focusKey.id&&el.id===focusKey.id)return true;
        return el.tagName===focusKey.tag&&((focusKey.action&&el.dataset.action===focusKey.action)||(focusKey.name&&el.name===focusKey.name&&el.value===focusKey.value)||(focusKey.s&&el.dataset.s===focusKey.s)||(el.dataset.bank===focusKey.bank&&((focusKey.variant&&el.dataset.variant===focusKey.variant)||(focusKey.b&&el.dataset.b===focusKey.b)||(focusKey.special&&el.dataset.special===focusKey.special)||(focusKey.service&&el.dataset.service===focusKey.service))));
      });
      if(!replacement&&focusKey.b==='product')replacement=this.content.querySelector('.q-picked-product button');
      if(!replacement)replacement=this.content.querySelector('h2');
      if(replacement){if(replacement.tagName==='H2')replacement.setAttribute('tabindex','-1');replacement.focus({preventScroll:true});}
    }
  };
  Quote.prototype.renderErrors=function(){
    var errors=this.ui.errors;
    this.root.querySelector('[data-errors]').innerHTML=this.renderCopy(errors.length?"<div class=\"q-error-box\" role=\"alert\"><strong>__VBM_TEXT_t030__</strong><ul>"+errors.map(function(e){var b=e.bankId?this.bank(e.bankId):null;return '<li>'+(b?E(b.name)+': ':'')+E(this.errorText(e))+'</li>';},this).join('')+'</ul></div>':'');
    var self=this;
    errors.forEach(function(error){
      var candidates=Array.from(self.content.querySelectorAll('input,select,textarea'));
      var el=candidates.find(function(el){return (el.dataset.s===error.field||el.dataset.b===error.field||el.dataset.c===error.field)&&(!error.bankId||el.dataset.bank===error.bankId);});
      if(el)el.setAttribute('aria-invalid','true');
    });
  };
  Quote.prototype.renderAside=function(){
    var s=this.state,count=C.count(s)||s.expectedCount;
    this.aside.innerHTML=this.renderCopy("<div><span class=\"q-eyebrow\">__VBM_TEXT_t009__</span><h3>"+E((s.expectedCount||count)?this.text(Number(s.expectedCount||count)===1?'aside_count_one':'aside_count_many',{aantal:s.expectedCount||count}):"__VBM_TEXT_t031__")+'</h3><ul class="q-aside-items">'+s.banks.map(function(b){return '<li><strong>'+E(b.name)+' · '+E(b.quantity)+" __VBM_TEXT_t032__</strong><span>"+E(b.product?b.product.title:"__VBM_TEXT_t033__")+(b.type==='overzet'?' · overzet':'')+'</span><span>'+E(b.confirmed?"__VBM_TEXT_t034__":"__VBM_TEXT_t035__")+'</span></li>';}).join('')+'</ul>'+(s.installation?'<p>'+E(s.installation==='us'?"__VBM_TEXT_t036__":"__VBM_TEXT_t037__")+'</p>':'')+"</div><div class=\"q-aside-help\"><h3>__VBM_TEXT_t038__</h3><p>__VBM_TEXT_t039__</p><a href=\"tel:0850051009\">085-0051009</a><p class=\"q-mini\">__VBM_TEXT_t040__ <a href=\""+E(this.config.rootUrl)+"pages/advies\">__VBM_TEXT_t041__</a></p></div>");
  };
  Quote.prototype.submitLabel=function(){return {offerte:"__VBM_TEXT_t042__",inmeten:"__VBM_TEXT_t043__",advies:"__VBM_TEXT_t044__",showroom:"__VBM_TEXT_t045__"}[C.route(this.state)];};
  Quote.prototype.view_project=function(){
    var s=this.state;
    return "<h2>__VBM_TEXT_t046__</h2>"+
      choices("__VBM_TEXT_t047__",'materialKnown',[['yes',"__VBM_TEXT_t048__","__VBM_TEXT_t049__"],['no',"__VBM_TEXT_t050__","__VBM_TEXT_t051__"]],s.materialKnown)+
      (s.materialKnown?input(this.text(s.materialKnown==='no'?'count_optional':"t052"),{'data-s':'expectedCount',type:'number',min:1,max:999,step:1,value:s.expectedCount,placeholder:"__VBM_TEXT_t053__"}):'');
  };
  Quote.prototype.view_vensterbanken=function(){
    var s=this.state,b=this.bank();
    if(!b&&s.banks.length){this.ui.active=s.banks[0].id;b=this.bank();}
    var intro="<h2>__VBM_TEXT_t054__</h2>";
    var tabs='<div class="q-bank-list">'+s.banks.map(function(item){return '<button type="button" class="q-bank-tab '+(item.id===this.ui.active?'is-active':'')+'" data-action="bank" data-id="'+E(item.id)+'">'+E(item.name)+' · '+E(item.quantity)+'</button>';},this).join('')+'</div>';
    if(!b)return intro+button("__VBM_TEXT_t055__",'add-bank',false);
    var previous=s.banks[s.banks.indexOf(b)-1];
    var toolbar='<div class="q-bank-toolbar"><h3>'+E(b.name)+'</h3><div class="q-bank-tools">'+(previous?link("__VBM_TEXT_t056__",'copy-previous'):'')+link("__VBM_TEXT_t057__",'remove-bank',{'data-id':b.id})+'</div></div>';
    var fields='<div class="q-grid">'+input("__VBM_TEXT_t058__",{'data-b':'name','data-bank':b.id,value:b.name,maxlength:80,placeholder:"__VBM_TEXT_t059__"})+input("__VBM_TEXT_t060__",{'data-b':'quantity','data-bank':b.id,type:'number',min:1,max:999,step:1,value:b.quantity},"__VBM_TEXT_t061__")+'</div>';
    var types="<fieldset class=\"q-question\" data-question=\"type\"><legend>__VBM_TEXT_t062__</legend><div class=\"q-grid\">"+[['new',"__VBM_TEXT_t063__","__VBM_TEXT_t064__"],['overzet',"__VBM_TEXT_t065__","__VBM_TEXT_t066__"]].map(function(v){return '<label class="q-choice"><input type="radio" name="type-'+E(b.id)+'" data-b="type" data-bank="'+E(b.id)+'" value="'+v[0]+'"'+(b.type===v[0]?' checked':'')+'><span><span class="q-choice-svg" aria-hidden="true">'+drawing(v[0])+'</span><strong>'+v[1]+'</strong><small>'+v[2]+'</small></span></label>';}).join('')+'</div></fieldset>';
    var materials='';
    if(b.type){
      var selectedMaterial=this.config.materials.find(function(m){return m.handle===b.material;});
      if(b.product&&selectedMaterial&&!this.ui.showMaterials)materials="<div class=\"q-note q-row-head\" data-question=\"material\"><span>__VBM_TEXT_t067__ <strong>"+E(selectedMaterial.name)+'</strong></span>'+link("__VBM_TEXT_t068__",'change-material')+'</div>';
      else materials="<fieldset class=\"q-question\" data-question=\"material\"><legend>__VBM_TEXT_t069__</legend><div class=\"q-grid q-grid-3 q-materials\">"+this.materials(b).map(function(m){return '<label class="q-choice q-choice-card"><input type="radio" name="material-'+E(b.id)+'" data-b="material" data-bank="'+E(b.id)+'" value="'+E(m.handle)+'"'+(b.material===m.handle?' checked':'')+'>'+image(m.image,m.name)+'<span class="q-card-copy"><strong>'+E(m.name)+'</strong></span></label>';}).join('')+'</div></fieldset>';
    }
    var products=b.material?'<div data-question="product">'+(b.product&&(!this.ui.showProductPicker||C.requiredProduct(b))?'<div class="q-picked-product">'+image(b.product.image,b.product.title)+'<div><strong>'+E(b.product.title)+'</strong>'+(C.requiredProduct(b)?'':'<p>'+link("__VBM_TEXT_t070__",'change-product')+'</p>')+'</div></div>':"<h3>__VBM_TEXT_t071__</h3>"+input("__VBM_TEXT_t072__",{'data-product-search':true,value:this.ui.productSearch,placeholder:"__VBM_TEXT_t073__",type:'search'})+'<div data-product-results>'+this.productResults(b)+'</div>')+'</div>':'';
    var config=b.product?"<div class=\"q-options\"><div class=\"q-row-head\"><h3>__VBM_TEXT_t074__</h3><a class=\"q-link\" href=\""+E(b.product.url)+"\" target=\"_blank\" rel=\"noopener\">__VBM_TEXT_t075__</a></div>"+(this.ui.loading==='product:'+b.id?"<p class=\"q-loading\">__VBM_TEXT_t076__</p>":this.ui.productError?'<p class="q-error">'+E(this.ui.productError)+'</p>'+button("__VBM_TEXT_t077__",'retry-product',true):b.spec?this.options(b):'')+'</div>':'';
    var total=C.count(s),countNote=total>Number(s.expectedCount)?'<div class="q-note">'+E(this.text("t078",{aantal:total}))+' '+link(this.text("t079",{aantal:total}),'use-count')+'</div>':'';
    return intro+tabs+toolbar+fields+types+materials+products+config+countNote;
  };
  Quote.prototype.productResults=function(b){
    if(this.ui.catalogError)return '<p class="q-error">'+E(this.ui.catalogError)+'</p>'+button("__VBM_TEXT_t077__",'retry-catalog',true);
    var products=this.products(b);
    if(this.ui.loading==='catalog:'+b.id||!this.catalogs.get(b.material)||!this.catalogs.get(b.material).resolved)return "<p class=\"q-loading\">__VBM_TEXT_t080__</p>";
    var search=this.ui.productSearch.toLocaleLowerCase('nl-NL');
    products=products.filter(function(p){return p.title.toLocaleLowerCase('nl-NL').includes(search);});
    if(!products.length)return "<p class=\"q-note\">__VBM_TEXT_t081__</p>";
    return '<div class="q-grid q-grid-3">'+products.map(function(p){return '<label class="q-choice q-choice-card"><input type="radio" name="product-'+E(b.id)+'" data-b="product" data-bank="'+E(b.id)+'" value="'+E(p.handle)+'"'+(b.product&&b.product.id===p.id?' checked':'')+'>'+image(p.image,p.title)+'<span class="q-card-copy"><strong>'+E(p.title)+'</strong></span></label>';}).join('')+'</div>';
  };
  Quote.prototype.fillProducts=async function(){
    var b=this.bank();if(!b||!b.material)return;
    var handle=b.material,request=this.state,loading=this.catalog(handle),entry=this.catalogs.get(handle);
    try{var products=await loading;if(this.state!==request||this.catalogs.get(handle)!==entry)return;var dest=this.content.querySelector('[data-product-results]');if(dest&&this.bank()&&this.bank().material===handle)dest.innerHTML=this.renderCopy(this.productResults(this.bank()));}
    catch(e){if(this.state!==request||this.catalogs.has(handle)&&this.catalogs.get(handle)!==entry||!this.bank()||this.bank().material!==handle)return;this.ui.catalogError=e.message;var dest=this.content.querySelector('[data-product-results]');if(dest)dest.innerHTML=this.renderCopy(this.productResults(this.bank()));}
  };
  Quote.prototype.options=function(b){
    var spec=b.spec,at={'data-bank':b.id},f=C.features(b),html='';
    if(b.type==='overzet')html+="<p class=\"q-note\">__VBM_TEXT_t082__ <strong>__VBM_TEXT_t083__</strong>.</p>";
    if(spec.finishes.length)html+=select("__VBM_TEXT_t084__",Object.assign({'data-b':'finish'},at),spec.finishes,b.finish);
    if(spec.thicknesses.length===1)html+='<p class="q-note"><strong>'+(b.type==='overzet'?"__VBM_TEXT_t085__ ":"__VBM_TEXT_t086__ ")+E(spec.thicknesses[0].label)+'</strong></p>';
    else if(spec.thicknesses.length)html+=select(b.type==='overzet'?"__VBM_TEXT_t087__":"__VBM_TEXT_t088__",Object.assign({'data-b':'thickness'},at),spec.thicknesses,b.thickness);
    else if(spec.freeThickness)html+=input("__VBM_TEXT_t089__",Object.assign({'data-b':'thickness',inputmode:'decimal',value:b.thickness,placeholder:"__VBM_TEXT_t090__"},at));
    spec.variants.forEach(function(v){html+=select(v.name,Object.assign({'data-variant':v.name},at),v.values,b.variants[v.name]);});
    if(spec.widths.length>1)html+=select("__VBM_TEXT_t091__",Object.assign({'data-b':'stockWidth'},at),spec.widths,b.stockWidth);
    if(spec.lengths.length>1)html+=select("__VBM_TEXT_t092__",Object.assign({'data-b':'stockLength'},at),spec.lengths,b.stockLength);
    if(f.paint){
      html+=check("__VBM_TEXT_t095__",Object.assign({'data-b':'colorLater'},at),b.colorLater);
      if(!b.colorLater){
        html+=select("__VBM_TEXT_t093__",Object.assign({'data-b':'brand'},at),spec.brands,b.brand,"__VBM_TEXT_t094__");
        if(b.brand)html+='<div data-question="color">'+this.palette(b,false)+'</div>';
        if(spec.paintGloss.length)html+=select("__VBM_TEXT_t096__",Object.assign({'data-b':'gloss'},at),spec.paintGloss,b.gloss);
      }
    }
    if(f.lacquer)html+=select("__VBM_TEXT_t097__",Object.assign({'data-b':'gloss'},at),spec.woodGloss,b.gloss);
    if(f.sanding)html+=check(spec.sanding[0].label,Object.assign({'data-b':'sanding'},at),b.sanding);
    if(f.rubio)html+='<div data-question="rubio">'+this.palette(b,true)+'</div>';
    if(spec.aluminium)html+=input("__VBM_TEXT_t098__",Object.assign({'data-custom-color':true,value:b.color?b.color.code:'',placeholder:"__VBM_TEXT_t099__"},at),"__VBM_TEXT_t100__");
    if(spec.sawing)html+=check("__VBM_TEXT_t101__",Object.assign({'data-b':'sawing'},at),b.sawing);
    if(spec.endcaps){
      html+=check("__VBM_TEXT_t102__",Object.assign({'data-b':'endcap'},at),b.endcap);
    }
    return html;
  };
  Quote.prototype.palette=function(b,rubio){
    var title=rubio?"__VBM_TEXT_t103__":"__VBM_TEXT_t104__",selected=rubio?b.rubio:b.color;
    var hex=selected&&/^#[0-9a-f]{6}$/i.test(selected.hex||'')?selected.hex:'#eee';
    if(selected&&!this.ui.colorPickerOpen)return '<h4>'+title+'</h4><div class="q-selected-color"><span class="q-selected-swatch" style="background:'+E(hex)+'" aria-hidden="true"></span><div><strong>'+E(selected.code||'')+' '+E(selected.name)+'</strong><p>'+link(rubio?"__VBM_TEXT_t105__":"__VBM_TEXT_t106__",'change-color',{'data-rubio':rubio?'yes':'no'})+'</p></div></div>';
    if(!rubio&&b.colorLater&&!this.ui.colorPickerOpen)return '<h4>'+title+"</h4><p class=\"q-note\">__VBM_TEXT_t107__ "+link("__VBM_TEXT_t108__",'change-color')+'</p>';
    return '<h4>'+title+'</h4>'+input("__VBM_TEXT_t109__",{'data-color-search':true,'data-rubio':rubio?'yes':'no',value:this.ui.colorSearch,placeholder:"__VBM_TEXT_t110__",type:'search'})+'<div data-color-results data-rubio="'+(rubio?'yes':'no')+'">'+this.colorResults(b,rubio)+'</div>'+(rubio?'':input("__VBM_TEXT_t111__",{'data-custom-color':true,'data-bank':b.id,value:b.color&&b.color.custom?b.color.code:'',placeholder:"__VBM_TEXT_t112__"}))+"<p class=\"q-hint\">__VBM_TEXT_t113__</p>";
  };
  Quote.prototype.colorValues=function(b,rubio){
    if(!this.colors)return [];
    if(rubio)return [].concat(this.colors.rubio.mainCollection||[],this.colors.rubio.preColors||[],this.colors.rubio.accentColors||[]);
    var brand=this.colors.paintBrands[b.brand];if(!brand)return [];
    return this.ui.colorSearch||this.ui.colorAll?brand.all:brand.popular;
  };
  Quote.prototype.colorResults=function(b,rubio){
    var all=this.colorValues(b,rubio),search=this.ui.colorSearch.toLowerCase().replace(/\s/g,'');
    var selected=rubio?b.rubio:b.color;
    var items=all.filter(function(c){return ((c.code||'')+(c.name||'')).toLowerCase().replace(/\s/g,'').includes(search);});
    var output='<div class="q-color-grid">'+items.slice(0,90).map(function(c){var hex=/^#[0-9a-f]{6}$/i.test(c.hex||'')?c.hex:'#eee';return '<button type="button" class="q-color" data-action="'+(rubio?'rubio':'color')+'" data-code="'+E(c.code||c.name)+'" aria-pressed="'+!!(selected&&(selected.code||selected.name)===(c.code||c.name))+'"><span class="q-swatch" style="background:'+hex+'"></span><strong>'+E(c.code||'')+'</strong><br>'+E(c.name)+'</button>';}).join('')+'</div>';
    if(!items.length)output="<p class=\"q-hint\">__VBM_TEXT_t114__</p>";
    if(!rubio&&!this.ui.colorAll&&!search)output+=link("__VBM_TEXT_t115__",'all-colors');
    if(items.length>90)output+="<p class=\"q-hint\">__VBM_TEXT_t116__</p>";
    return output;
  };

  Quote.prototype.view_maten=function(){
    var b=this.bank();if(!b)return "<h2>__VBM_TEXT_t003__</h2><p>__VBM_TEXT_t117__</p>";
    var a={'data-bank':b.id};
    var html="<h2>__VBM_TEXT_t003__</h2><div class=\"q-row-head\"><h3>"+E(b.name)+'</h3><span class="q-pill">'+E(b.quantity)+" __VBM_TEXT_t118__</span></div>"+
      "<div class=\"q-dimension-diagram\" aria-label=\"__VBM_TEXT_t121__\"><svg viewBox=\"0 0 500 145\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\"><rect x=\"30\" y=\"16\" width=\"380\" height=\"65\" rx=\"3\" fill=\"#f6f2fa\" stroke=\"#5919aa\" stroke-width=\"2\"/><path d=\"M30 112h380M30 106v12m380-12v12m30-96v59m-6-59h12m-12 59h12\" stroke=\"#5919aa\" stroke-width=\"1.8\"/><text x=\"220\" y=\"139\" text-anchor=\"middle\" fill=\"#5919aa\" font-size=\"15\" font-family=\"Arial\">__VBM_TEXT_t119__</text><text x=\"453\" y=\"54\" fill=\"#5919aa\" font-size=\"14\" font-family=\"Arial\">__VBM_TEXT_t120__</text></svg></div>";
    html+=select("__VBM_TEXT_t122__",Object.assign({'data-b':'unit'},a),[['cm',"__VBM_TEXT_t123__"],['mm',"__VBM_TEXT_t124__"]],b.unit,null,false);
    html+='<div class="q-grid">'+input(this.text("t125",{eenheid:this.text(b.unit==='cm'?'unit_cm_label':'unit_mm_label')}),Object.assign({'data-b':'length',inputmode:'decimal',value:b.length,placeholder:b.unit==='cm'?"__VBM_TEXT_t126__":"__VBM_TEXT_t127__"},a))+
      input(this.text("t128",{eenheid:this.text(b.unit==='cm'?'unit_cm_label':'unit_mm_label')}),Object.assign({'data-b':'width',inputmode:'decimal',value:b.width,placeholder:b.unit==='cm'?"__VBM_TEXT_t090__":"__VBM_TEXT_t129__"},a))+'</div>';
    if(b.type==='overzet'){
      html+="<p class=\"q-note\">__VBM_TEXT_t130__</p>";
    }else html+=select("__VBM_TEXT_t131__",Object.assign({'data-b':'existing'},a),[['yes',"__VBM_TEXT_t132__"],['no',"__VBM_TEXT_t133__"],['unknown',"__VBM_TEXT_t134__"]],b.existing);
    if(b.existing==='yes'||b.type==='overzet')html+=select("__VBM_TEXT_t135__",Object.assign({'data-b':'oldMaterial'},a),[['Steen of composiet',"__VBM_TEXT_t136__"],['Beton',"__VBM_TEXT_t137__"],['Tegels',"__VBM_TEXT_t138__"],['Hout of MDF',"__VBM_TEXT_t139__"],['Kunststof',"__VBM_TEXT_t140__"],['Anders',"__VBM_TEXT_t141__"],['Weet ik niet',"__VBM_TEXT_t142__"]],b.oldMaterial);
    html+="<fieldset class=\"q-question\" data-question=\"specials\"><legend>__VBM_TEXT_t143__</legend><p class=\"q-hint\">__VBM_TEXT_t144__</p><div class=\"q-specials\">"+C.SPECIALS.map(function(v){return check(copyDefault(v[1]),Object.assign({'data-special':v[0]},a),b.specials.includes(v[0]));}).join('')+'</div></fieldset>';
    if(b.specials.includes('anders'))html+=textarea("__VBM_TEXT_t145__",Object.assign({'data-b':'specialText',maxlength:1500},a),b.specialText);
    if(this.state.installation==='us')html+="<fieldset class=\"q-question\" data-question=\"extras\"><legend>__VBM_TEXT_t146__</legend><div class=\"q-specials\">"+C.SERVICES.filter(function(v){return !(v[0]==='demontage'&&(b.type==='overzet'||b.existing==='no'))&&!(v[0]==='afvoeren'&&b.existing==='no');}).map(function(v){return check(copyDefault(v[1]),Object.assign({'data-service':v[0]},a),b.services[v[0]]);}).join('')+'</div></fieldset>';
    if(this.state.measurement==='us')html+='<div data-question="measure">'+check("__VBM_TEXT_t147__",Object.assign({'data-b':'measure'},a),b.measure)+'</div>';
    html+=textarea("__VBM_TEXT_t148__",Object.assign({'data-b':'note',maxlength:2000},a),b.note);
    return html;
  };
  Quote.prototype.view_diensten=function(){
    var s=this.state;
    return "<h2>__VBM_TEXT_t149__</h2>"+
      choices("__VBM_TEXT_t150__",'measurement',[['self',"__VBM_TEXT_t151__","__VBM_TEXT_t152__"],['us',"__VBM_TEXT_t153__","__VBM_TEXT_t154__"]],s.measurement)+
      "<p class=\"q-hint q-measure-hint\">__VBM_TEXT_t155__</p>"+
      choices("__VBM_TEXT_t156__",'installation',[['self',"__VBM_TEXT_t037__","__VBM_TEXT_t157__"],['us',"__VBM_TEXT_t036__","__VBM_TEXT_t158__"]],s.installation)+
      (s.installation==='self'?choices("__VBM_TEXT_t159__",'delivery',[['pickup',"__VBM_TEXT_t160__","__VBM_TEXT_t161__"],['delivery',"__VBM_TEXT_t162__","__VBM_TEXT_t163__"]],s.delivery):'')+
      input("__VBM_TEXT_t164__",{'data-s':'timing',value:s.timing,maxlength:150,placeholder:"__VBM_TEXT_t165__"},"__VBM_TEXT_t166__");
  };
  Quote.prototype.view_advies=function(){
    var s=this.state;
    return "<h2>__VBM_TEXT_t167__</h2>"+
      choices("__VBM_TEXT_t168__",'adviceKind',[['phone',"__VBM_TEXT_t169__","__VBM_TEXT_t170__"],['email',"__VBM_TEXT_t171__","__VBM_TEXT_t172__"],['showroom',"__VBM_TEXT_t173__","__VBM_TEXT_t174__"]],s.adviceKind,null,3)+
      select("__VBM_TEXT_t175__",{'data-s':'adviceTopic'},[['Materiaal en uitstraling',"__VBM_TEXT_t176__"],['Kleur en afwerking',"__VBM_TEXT_t177__"],['Inmeten of plaatsen',"__VBM_TEXT_t178__"],['Mijn complete project',"__VBM_TEXT_t179__"],['Een andere vraag',"__VBM_TEXT_t180__"]],s.adviceTopic)+
      (s.adviceKind&&s.adviceKind!=='email'?'<div class="q-grid">'+input("__VBM_TEXT_t181__",{'data-s':'preferredDate',value:s.preferredDate,maxlength:100,placeholder:"__VBM_TEXT_t182__"})+input("__VBM_TEXT_t183__",{'data-s':'preferredPart',value:s.preferredPart,maxlength:100,placeholder:"__VBM_TEXT_t184__"})+'</div>':'')+
      (s.adviceKind==='showroom'?"<p class=\"q-note\">__VBM_TEXT_t185__</p>":'');
  };
  Quote.prototype.view_gegevens=function(){
    var s=this.state,c=s.contact,address=!['advies','showroom'].includes(C.route(s));
    return "<h2>__VBM_TEXT_t186__</h2><div class=\"q-grid\">"+
      input("__VBM_TEXT_t187__",{'data-c':'name',autocomplete:'name',value:c.name,maxlength:120,placeholder:"__VBM_TEXT_t188__"})+
      input("__VBM_TEXT_t189__",{'data-c':'phone',type:'tel',autocomplete:'tel',value:c.phone,maxlength:40,placeholder:"__VBM_TEXT_t190__"})+
      '<div class="q-wide">'+input("__VBM_TEXT_t191__",{'data-c':'email',type:'email',autocomplete:'email',value:c.email,maxlength:254,autocapitalize:'off',spellcheck:'false',placeholder:"__VBM_TEXT_t192__"})+'</div>'+
      (address?input("__VBM_TEXT_t193__",{'data-c':'street',autocomplete:'address-line1',value:c.street,maxlength:150,placeholder:"__VBM_TEXT_t194__"})+'<div class="q-grid">'+input("__VBM_TEXT_t195__",{'data-c':'number',value:c.number,inputmode:'numeric',maxlength:15,placeholder:"__VBM_TEXT_t196__"})+input("__VBM_TEXT_t197__",{'data-c':'addition',value:c.addition,maxlength:20,placeholder:"__VBM_TEXT_t198__"})+'</div>'+input("__VBM_TEXT_t199__",{'data-c':'postcode',autocomplete:'postal-code',value:c.postcode,maxlength:10,placeholder:"__VBM_TEXT_t200__"}):'')+
      input((address?"__VBM_TEXT_t201__":"__VBM_TEXT_t202__")+' *',{'data-c':'city',autocomplete:'address-level2',value:c.city,maxlength:100,placeholder:"__VBM_TEXT_t203__"})+
      '</div>'+textarea("__VBM_TEXT_t204__",{'data-s':'message',maxlength:5000},s.message,"__VBM_TEXT_t205__");
  };
  function dl(rows){
    return '<dl class="q-dl">'+rows.filter(function(row){return row[1]!=null&&row[1]!=='';}).map(function(row){return '<dt>'+E(row[0])+'</dt><dd>'+E(row[1])+'</dd>';}).join('')+'</dl>';
  }
  Quote.prototype.view_controle=function(){
    var s=this.state,route=C.route(s),c=s.contact,html="<h2>__VBM_TEXT_t206__</h2><p class=\"q-subtext\">__VBM_TEXT_t207__</p>";
    html+='<section class="q-review"><div class="q-review-head"><h3>'+E(this.text('route_'+route))+'</h3>'+link("__VBM_TEXT_t208__",'edit',{'data-step':'project'})+'</div>'+dl([
      ["__VBM_TEXT_t209__",route==='offerte'?C.count(s):(s.expectedCount||"__VBM_TEXT_t210__")],
      ["__VBM_TEXT_t211__",s.installation?(s.installation==='us'?"__VBM_TEXT_t036__":"__VBM_TEXT_t037__"):''],
      ["__VBM_TEXT_t212__",s.measurement?(s.measurement==='us'?"__VBM_TEXT_t153__":"__VBM_TEXT_t151__"):''],
      ["__VBM_TEXT_t213__",s.installation==='us'?'':s.delivery==='pickup'?"__VBM_TEXT_t160__":s.delivery==='delivery'?"__VBM_TEXT_t162__":''],
      ["__VBM_TEXT_t214__",s.timing],["__VBM_TEXT_t215__",s.adviceKind?({phone:"__VBM_TEXT_t216__",email:"__VBM_TEXT_t217__",showroom:"__VBM_TEXT_t218__"}[s.adviceKind]):''],
      ["__VBM_TEXT_t219__",s.adviceTopic],["__VBM_TEXT_t220__",[s.preferredDate,s.preferredPart].filter(Boolean).join(', ')]
    ])+'</section>';
    s.banks.forEach(function(b){
      var f=C.features(b);
      html+='<section class="q-review"><div class="q-review-head"><h3>'+E(b.name)+' · '+E(b.quantity)+" __VBM_TEXT_t118__</h3>"+link("__VBM_TEXT_t208__",'edit',{'data-step':'vensterbanken','data-id':b.id})+'</div>'+dl([
        ["__VBM_TEXT_t074__",b.type==='overzet'?"__VBM_TEXT_t065__":b.type==='new'?"__VBM_TEXT_t063__":"__VBM_TEXT_t221__"],
        ["__VBM_TEXT_t222__",b.product?b.product.title:"__VBM_TEXT_t223__"],["__VBM_TEXT_t084__",b.finish],["__VBM_TEXT_t088__",b.thickness?b.thickness+' millimeter':''],
        ["__VBM_TEXT_t093__",!b.colorLater&&b.brand?({ral:'RAL',sikkens:'Sikkens',farrow:'Farrow & Ball',greene:'Little Greene'}[b.brand]||b.brand):''],
        ["__VBM_TEXT_t224__",b.colorLater?"__VBM_TEXT_t225__":b.color?b.color.code+' · '+b.color.name:''],
        ["__VBM_TEXT_t096__",b.colorLater?'':b.gloss],["__VBM_TEXT_t226__",b.rubio?b.rubio.name:''],["__VBM_TEXT_t227__",b.sanding?"__VBM_TEXT_t228__":''],
        ["__VBM_TEXT_t229__",b.stockWidth?b.stockWidth+' millimeter':''],["__VBM_TEXT_t230__",b.stockLength?b.stockLength+' millimeter':''],
        ["__VBM_TEXT_t231__",b.length&&b.width?b.length+' × '+b.width+' '+b.unit+' (geschat; lengte × breedte)':"__VBM_TEXT_t232__"],
        ["__VBM_TEXT_t233__",b.type==='overzet'?"__VBM_TEXT_t234__":({yes:"__VBM_TEXT_t235__",no:"__VBM_TEXT_t236__",unknown:"__VBM_TEXT_t210__"}[b.existing]||'')],
        ["__VBM_TEXT_t237__",b.oldMaterial],
        ["__VBM_TEXT_t238__",b.specials.map(function(k){var v=C.SPECIALS.find(function(v){return v[0]===k;});return v?copyDefault(v[1]):k;}).join(', ')],
        ["__VBM_TEXT_t239__",b.specialText],
        ["__VBM_TEXT_t240__",s.installation==='us'?(C.SERVICES.filter(function(v){return b.services[v[0]];}).map(function(v){return copyDefault(v[1]);}).join(', ')||"__VBM_TEXT_t241__"):''],
        ["__VBM_TEXT_t242__",b.sawing?"__VBM_TEXT_t243__":''],
        ["__VBM_TEXT_t244__",b.spec&&b.spec.endcaps?(b.endcap?"__VBM_TEXT_t243__":"__VBM_TEXT_t245__"):''],
        ["__VBM_TEXT_t153__",s.measurement==='us'?(b.measure?"__VBM_TEXT_t246__":"__VBM_TEXT_t247__"):''],["__VBM_TEXT_t248__",b.note]
      ].concat(Object.keys(b.variants||{}).map(function(k){return [k,b.variants[k]];})))+(b.product?'<p class="q-hint"><a href="'+E(b.product.url)+"\" target=\"_blank\" rel=\"noopener\">__VBM_TEXT_t249__</a></p>":'')+'</section>';
    });
    html+="<section class=\"q-review\"><div class=\"q-review-head\"><h3>__VBM_TEXT_t250__</h3>"+link("__VBM_TEXT_t208__",'edit',{'data-step':'gegevens'})+'</div>'+dl([
      ["__VBM_TEXT_t251__",c.name],["__VBM_TEXT_t252__",c.phone],["__VBM_TEXT_t253__",c.email],
      ["__VBM_TEXT_t254__",[c.street,c.number,c.addition].filter(Boolean).join(' ')],
      ["__VBM_TEXT_t255__",[c.postcode,c.city].filter(Boolean).join(' ')],["__VBM_TEXT_t256__",s.message]
    ])+'</section>';
    if(s.photos.length)html+="<section class=\"q-review\"><h3>__VBM_TEXT_t257__</h3><ul class=\"q-photo-list\">"+s.photos.map(function(p){var b=p.bankId?this.bank(p.bankId):null;return '<li><a href="'+E(p.url)+'" target="_blank" rel="noopener">'+E(p.name)+'</a> · '+E(b?b.name:"__VBM_TEXT_photo_general__")+'</li>';},this).join('')+'</ul></section>';
    return html+"<p class=\"q-note\">__VBM_TEXT_t258__ <strong>__VBM_TEXT_t259__</strong> __VBM_TEXT_t260__</p>";
  };
  Quote.prototype.renderPhotos=function(){
    var visible=this.state.step==='maten'||this.state.step==='advies';
    if(this.state.step==='maten'&&this.ui.photoForBank!==this.ui.active&&!this.ui.pendingPhotos.length){this.ui.photoTarget=this.ui.active;this.ui.photoForBank=this.ui.active;}
    this.photoPanel.hidden=!visible;
    var target=this.root.querySelector('[data-photo-target]');
    target.innerHTML=this.renderCopy("<option value=\"\">__VBM_TEXT_photo_general__</option>"+this.state.banks.map(function(b){return '<option value="'+E(b.id)+'">'+E(b.name)+'</option>';}).join(''));
    if(this.ui.photoTarget&&!this.bank(this.ui.photoTarget))this.ui.photoTarget='';
    target.value=this.ui.photoTarget;
    target.disabled=this.ui.pendingPhotos.length>0;
    this.root.querySelector('[data-photo-list]').innerHTML=this.renderCopy(this.state.photos.map(function(p){
      var b=p.bankId?this.bank(p.bankId):null;
      return '<li><a href="'+E(p.url)+'" target="_blank" rel="noopener">'+E(p.name)+'</a> · '+E(b?b.name:"__VBM_TEXT_photo_general__")+' '+link("__VBM_TEXT_t261__",'remove-photo',{'data-url':p.url})+'</li>';
    },this).join(''));
    this.root.querySelector('[data-photo-status]').innerHTML=this.renderCopy(this.ui.pendingPhotos.length?"<p class=\"q-note\">__VBM_TEXT_t262__ "+link("__VBM_TEXT_t263__",'reset-upload')+'</p>':'');
    if(visible)this.ensureUploader();
  };
  Quote.prototype.ensureUploader=function(){
    if(!this.dialog.open||!this.upload||this.photoPanel.hidden||this.upload.querySelector('input[type="file"]')||this.ui.pendingPhotos.length||this.ui.uploadSetupRequested)return;
    var app=window.Cloudlift&&window.Cloudlift.upload&&window.Cloudlift.upload.App;
    if(app&&typeof app.setup==='function'){this.ui.uploadSetupRequested=true;try{app.setup(true);}catch(e){this.ui.uploadSetupRequested=false;}}
  };
  Quote.prototype.photoAvailability=function(finalCheck){
    if(finalCheck)this.ensureUploader();
    var present=!!this.upload.querySelector('input[type="file"]');
    var fallback=this.root.querySelector('[data-photo-fallback]');
    if(fallback) {
      fallback.hidden=present;
      if(finalCheck&&!present)fallback.textContent=this.resolveText("__VBM_TEXT_t264__");
    }
  };
  Quote.prototype.next=function(){
    ++this.ui.navigationToken;
    var step=this.state.step,b=this.bank(),perBank=step==='vensterbanken'||step==='maten';
    this.ui.errors=C.validate(this.state,step,perBank&&b?b.id:null);
    if(step==='maten'&&b)this.ui.errors=C.validate(this.state,'vensterbanken',b.id).concat(this.ui.errors);
    if(step==='maten'&&b&&this.state.measurement==='us'&&C.count(this.state)===Number(this.state.expectedCount)&&!this.state.banks.some(function(item){return item.measure;}))this.ui.errors.push({field:'measure',bankId:b.id,message:"__VBM_TEXT_t265__"});
    if(this.ui.pendingPhotos.length)this.ui.errors.push({field:'photos',message:"__VBM_TEXT_t266__"});
    if(this.ui.loading)this.ui.errors.push({field:'product',message:"__VBM_TEXT_t267__"});
    if(perBank&&b&&C.count(this.state)>Number(this.state.expectedCount))this.ui.errors.push({field:'quantity',bankId:b.id,message:"__VBM_TEXT_t268__"});
    if(this.ui.errors.length){
      if(step==='maten'&&b&&C.validate(this.state,'vensterbanken',b.id).length)this.state.step='vensterbanken';
      this.render();this.focus();return;
    }
    if(step==='maten'&&b){
      b.confirmed=true;
      var index=this.state.banks.indexOf(b),next=this.state.banks[index+1]||this.state.banks.find(function(item){return !item.confirmed;});
      if(this.ui.returnToReview&&C.count(this.state)===Number(this.state.expectedCount)&&this.state.banks.every(function(item){return item.confirmed;})){
        this.state.step='controle';this.ui.returnToReview=false;
      }else if(next){this.ui.active=next.id;this.state.step='vensterbanken';}
      else if(C.count(this.state)<Number(this.state.expectedCount)){
        this.state.step='vensterbanken';this.addBank();
      }else this.state.step='gegevens';
    }else if(step==='project')this.state.step=this.state.materialKnown==='no'?'advies':'diensten';
    else if(step==='diensten'){
      if(this.ui.returnToReview&&C.allErrors(this.state).length===0){this.state.step='controle';this.ui.returnToReview=false;}
      else{
        this.state.step='vensterbanken';
        if(!this.state.banks.length)this.addBank();
        else this.ui.active=(this.state.banks.find(function(item){return !item.confirmed;})||this.state.banks[0]).id;
      }
    }else if(step==='vensterbanken')this.state.step='maten';
    else if(step==='advies')this.state.step='gegevens';
    else if(step==='gegevens')this.state.step='controle';
    if(this.state.step==='controle')this.ui.returnToReview=false;
    this.ui.showMaterials=false;this.ui.showProductPicker=false;this.ui.colorPickerOpen=false;
    this.ui.errors=[];this.render();this.save();this.focus();
  };
  Quote.prototype.previous=function(){
    ++this.ui.navigationToken;
    var step=this.state.step,b=this.bank(),index=this.state.banks.indexOf(b);
    if(step==='maten')this.state.step='vensterbanken';
    else if(step==='vensterbanken'&&index>0){this.ui.active=this.state.banks[index-1].id;this.state.step='maten';}
    else if(step==='vensterbanken')this.state.step='diensten';
    else if(step==='gegevens'&&this.state.materialKnown!=='no'){
      var last=this.state.banks[this.state.banks.length-1];this.ui.active=last?last.id:null;this.state.step=last?'maten':'diensten';
    }else{var steps=C.steps(this.state),i=steps.indexOf(step);if(i)this.state.step=steps[i-1];}
    this.ui.errors=[];this.render();this.save();this.focus();
  };
  Quote.prototype.bind=function(){
    var self=this;
    this.root.addEventListener('click',function(event){
      var el=event.target.closest('[data-action]');if(!el||!self.root.contains(el))return;
      event.preventDefault();var action=el.dataset.action,b=self.bank(el.dataset.id);
      if(action==='restart-request'||action==='restart')self.requestRestart();
      else if(action==='restart-cancel')self.cancelRestart(true);
      else if(action==='restart-confirm'||action==='restart-success'){
        self.startOver();
      }else if(action==='next')self.next();
      else if(action==='previous')self.previous();
      else if(action==='resume'){
        self.state=self.ui.resume;self.ui.resume=null;self.ui.active=self.state.banks[0]?self.state.banks[0].id:null;self.render();self.refreshRestored();self.save();
      }else if(action==='add-bank')self.addBank();
      else if(action==='change-product'){++self.ui.navigationToken;self.ui.showProductPicker=true;self.ui.productSearch='';self.render();self.jumpTo(self.content.querySelector('[data-question="product"]'));}
      else if(action==='change-material'){++self.ui.navigationToken;self.ui.showMaterials=true;self.render();self.jumpTo(self.content.querySelector('[data-question="material"]'));}
      else if(action==='bank'){++self.ui.navigationToken;self.ui.active=el.dataset.id;self.ui.productSearch='';self.ui.colorPickerOpen=false;self.ui.showProductPicker=false;self.ui.showMaterials=false;self.ui.errors=[];self.render();self.focus();}
      else if(action==='copy-previous'){
        ++self.ui.navigationToken;var current=self.bank(),position=self.state.banks.indexOf(current),previous=self.state.banks[position-1];
        if(previous){var copied=JSON.parse(JSON.stringify(previous));copied.id=current.id;copied.name=current.name;copied.quantity=current.quantity;copied.confirmed=false;self.state.banks[position]=copied;self.ui.colorPickerOpen=false;self.render();self.save();self.announce("__VBM_TEXT_t269__");self.focus();}
      }
      else if(action==='remove-bank'&&b){
        ++self.ui.navigationToken;self.undo=JSON.parse(JSON.stringify(b));self.state.banks=self.state.banks.filter(function(item){return item.id!==b.id;});
        self.state.photos.forEach(function(p){if(p.bankId===b.id)p.bankId='';});self.ui.active=self.state.banks[0]?self.state.banks[0].id:null;self.render();self.save();
        self.announce(self.text('removed_sill',{naam:b.name}));self.root.querySelector('[data-resume]').innerHTML=self.renderCopy("<p class=\"q-note\">__VBM_TEXT_t270__ "+link("__VBM_TEXT_t271__",'undo-bank')+'</p>');
      }else if(action==='undo-bank'&&self.undo){self.state.banks.push(self.undo);self.ui.active=self.undo.id;self.undo=null;self.render();self.save();}
      else if(action==='use-count'){self.state.expectedCount=C.count(self.state);self.ui.errors=[];self.render();self.save();}
      else if(action==='retry-catalog')self.selectMaterial(self.bank(),self.bank().material,true);
      else if(action==='retry-product')self.selectProduct(self.bank(),self.bank().product.handle,true);
      else if(action==='all-colors'){self.ui.colorAll=true;self.ui.colorPickerOpen=true;self.render();self.jumpTo(self.content.querySelector('[data-question="color"]'));}
      else if(action==='change-color'){self.ui.colorPickerOpen=true;self.ui.colorAll=false;self.ui.colorSearch='';var selected=self.bank();if(selected&&el.dataset.rubio!=='yes')selected.colorLater=false;self.render();self.jumpTo(self.content.querySelector('[data-question="'+(el.dataset.rubio==='yes'?'rubio':'color')+'"]'));}
      else if(action==='color'||action==='rubio'){
        b=self.bank();var color=self.colorValues(b,action==='rubio').find(function(c){return (c.code||c.name)===el.dataset.code;});
        if(color){++self.ui.navigationToken;b.confirmed=false;if(action==='rubio')b.rubio=color;else{b.color=color;b.colorLater=false;}self.ui.colorAll=false;self.ui.colorSearch='';self.ui.colorPickerOpen=false;self.render();self.save();self.nextQuestion(action==='rubio'?'rubio':'color',b.id);}
      }else if(action==='edit'){
        ++self.ui.navigationToken;self.ui.returnToReview=true;self.state.step=el.dataset.step;if(el.dataset.id)self.ui.active=el.dataset.id;self.ui.errors=[];self.render();self.save();self.focus();
      }else if(action==='remove-photo'){
        self.state.photos=self.state.photos.filter(function(p){return p.url!==el.dataset.url;});self.renderPhotos();self.save();
      }else if(action==='reset-upload'){
        self.ui.pendingPhotos=[];self.renderPhotos();
        var app=window.Cloudlift&&window.Cloudlift.upload&&window.Cloudlift.upload.App;
        if(app&&typeof app.setup==='function')app.setup(true);
        self.announce("__VBM_TEXT_t272__");self.save();
      }
    });
    this.root.addEventListener('input',function(event){self.change(event,false);});
    this.root.addEventListener('change',function(event){self.change(event,true);});
    this.root.addEventListener('change',function(event){
      if(event.target.type!=='file'||!self.upload.contains(event.target))return;
      Array.from(event.target.files||[]).forEach(function(f){if(f.size>10*1024*1024){self.announce("__VBM_TEXT_t273__");return;}self.ui.pendingPhotos.push({name:f.name,bankId:self.ui.photoTarget});});self.renderPhotos();
    },true);
    this.root.addEventListener('upload:added',function(event){
      if(!self.upload.contains(event.target)&&event.target!==self.upload)return;
      var photo=C.safePhoto(event.detail);if(!photo)return;
      var index=self.ui.pendingPhotos.findIndex(function(p){return p.name===photo.name;});
      if(index<0&&self.ui.pendingPhotos.length)index=0;
      var pending=index>=0?self.ui.pendingPhotos.splice(index,1)[0]:null;
      photo.bankId=pending?pending.bankId:self.ui.photoTarget;
      if(!self.state.photos.some(function(p){return p.url===photo.url;}))self.state.photos.push(photo);
      self.renderPhotos();self.save();self.announce("__VBM_TEXT_t274__");
    });
    this.root.addEventListener('upload:removed',function(event){
      if(!self.upload.contains(event.target)&&event.target!==self.upload)return;
      var photo=C.safePhoto(event.detail),name=event.detail&&(event.detail.name||event.detail.filename||event.detail.fileName);
      if(name)self.ui.pendingPhotos=self.ui.pendingPhotos.filter(function(p){return p.name!==name;});
      if(photo)self.state.photos=self.state.photos.filter(function(p){return p.url!==photo.url;});
      self.renderPhotos();self.save();
    });
    this.form.addEventListener('submit',function(event){self.submit(event);});
    window.addEventListener('pageshow',function(){self.ui.submitting=false;self.updateRestartControls();var button=self.root.querySelector('[data-send]');if(button){button.disabled=false;button.textContent=self.resolveText(self.submitLabel());}});
  };
  Quote.prototype.change=function(event,finished){
    var el=event.target;if(!el||!this.root.contains(el))return;
    if(!finished&&(el.tagName==='SELECT'||['radio','checkbox','file'].includes(el.type)))return;
    if(el.matches('[data-photo-target]')){this.ui.photoTarget=el.value;return;}
    if(el.matches('[data-product-search]')){
      this.ui.productSearch=el.value;var productResult=this.content.querySelector('[data-product-results]');if(productResult&&this.bank())productResult.innerHTML=this.renderCopy(this.productResults(this.bank()));return;
    }
    if(el.matches('[data-color-search]')){
      this.ui.colorSearch=el.value;var colorResult=this.content.querySelector('[data-color-results]');if(colorResult&&this.bank())colorResult.innerHTML=this.renderCopy(this.colorResults(this.bank(),el.dataset.rubio==='yes'));return;
    }
    var b=this.bank(el.dataset.bank),value=el.type==='checkbox'?el.checked:el.value;
    var render=finished&&(el.tagName==='SELECT'||['radio','checkbox'].includes(el.type));
    var parentQuestion=el.closest('[data-question]'),questionKey=parentQuestion?parentQuestion.dataset.question:null;
    var shouldJump=render&&(el.tagName==='SELECT'||el.type==='radio'||['colorLater','endcap','sanding'].includes(el.dataset.b)||(el.dataset.special==='anders'&&el.checked));
    if(render)++this.ui.navigationToken;
    if(el.dataset.c)this.state.contact[el.dataset.c]=value;
    else if(el.dataset.s){
      if(el.dataset.s==='installation')C.setInstallation(this.state,value);
      else this.state[el.dataset.s]=value;
      if(el.dataset.s==='measurement'&&value==='us'&&!this.state.banks.some(function(item){return item.measure;}))this.state.banks.forEach(function(item){item.measure=true;});
    }else if(b&&el.dataset.b){
      b.confirmed=false;var key=el.dataset.b;
      if(key==='material'){if(finished)this.selectMaterial(b,value);return;}
      if(key==='product'){if(finished)this.selectProduct(b,value);return;}
      if(key==='unit'&&finished){b.length=C.convert(b.length,b.unit,value);b.width=C.convert(b.width,b.unit,value);}
      if(key==='type'&&finished&&b.type!==value){
        b.type=value;
        if(b.material&&!this.materials(b).some(function(m){return m.handle===b.material;})){b.material='';b.product=null;b.spec=null;b.finish='';b.thickness='';b.brand='';b.color=null;b.colorLater=false;b.gloss='';b.variants={};}
        else if(b.spec)C.applySpec(b,b.spec);
        if(C.requiredProduct(b)){C.clearInapplicable(b);this.selectMaterial(b,b.material);return;}
      }else b[key]=value;
      if(key==='brand'){b.color=null;b.colorLater=false;this.ui.colorSearch='';this.ui.colorAll=false;this.ui.colorPickerOpen=false;}
      if(key==='colorLater'&&value){b.color=null;this.ui.colorPickerOpen=false;}
      C.clearInapplicable(b);
      if(key==='finish'&&b.spec){
        var feature=C.features(b),gloss=feature.lacquer?b.spec.woodGloss:feature.paint?b.spec.paintGloss:[];
        if(!b.colorLater&&gloss.length&&!gloss.some(function(v){return v.value===b.gloss;}))b.gloss=gloss[0].value;
      }
      if(key==='colorLater')questionKey='colorLater';
    }else if(b&&el.dataset.special){b.confirmed=false;b.specials=C.toggleSpecial(b.specials,el.dataset.special,el.checked);}
    else if(b&&el.dataset.service){if(this.state.installation!=='us')return;b.confirmed=false;b.services[el.dataset.service]=el.checked;C.clearInapplicable(b);}
    else if(b&&el.dataset.variant){b.confirmed=false;b.variants[el.dataset.variant]=value;}
    else if(b&&el.hasAttribute('data-custom-color')){
      b.confirmed=false;b.color=value.trim()?{code:value.trim(),name:'Opgegeven kleur',custom:true}:null;b.colorLater=false;
    }else return;
    if(render){this.ui.errors=[];this.render();if(shouldJump&&questionKey)this.nextQuestion(questionKey,b&&el.dataset.bank?b.id:null);}
    else{el.removeAttribute('aria-invalid');this.renderAside();if(el.dataset.b==='quantity'&&this.state.step==='maten')this.actions.querySelector('[data-action="next"]').textContent=this.resolveText(this.confirmLabel());}
    this.save();
  };
  Quote.prototype.refreshRestored=async function(){
    var self=this,request=this.state;
    await Promise.allSettled(request.banks.filter(function(b){return b.material;}).map(async function(b){
      try{var products=await self.catalog(b.material),required=C.requiredProduct(b);if(self.state!==request)return;if(required){var product=products.find(function(p){return p.handle===required;});if(!product)throw new Error('__VBM_TEXT_error_mdf_overlay__');self.assignProduct(b,product);}if(b.product){var spec=await self.getSpec(b.product);if(self.state===request)C.applySpec(b,spec);}}
      catch(e){if(self.state===request){b.spec=null;self.ui.productError="__VBM_TEXT_t275__";}}
    }));
    if(this.state!==request)return;
    self.render();self.save();
  };
  Quote.prototype.prepareMail=function(){
    var container=this.form.querySelector('[data-quote-mail-fields]');
    if(!container)throw new Error('Mailvelden ontbreken.');
    container.replaceChildren();
    var fields=C.mailFields(this.state,{templates:this.config.mailTemplates,materials:this.config.materials,spacing:this.config.mailSpacing});
    var length=fields.reduce(function(total,field){return total+field.key.length+field.value.length;},this.state.contact.email.length);
    if(length>95000)return false;
    fields.forEach(function(field){var input=document.createElement('textarea');input.name='contact['+field.key+']';input.hidden=true;input.setAttribute('data-quote-mail-field','');input.setAttribute('data-mail-label',field.label);input.value=field.value;container.appendChild(input);});
    this.form.querySelector('[data-post="email"]').value=this.state.contact.email;
    return true;
  };
  Quote.prototype.submit=function(event){
    if(this.ui.restartConfirm){event.preventDefault();return;}
    if(this.ui.submitting){event.preventDefault();return;}
    if(this.state.step!=='controle'){event.preventDefault();this.next();return;}
    var errors=C.allErrors(this.state);
    if(this.ui.pendingPhotos.length)errors.push({field:'photos',message:"__VBM_TEXT_t266__"});
    if(this.ui.loading)errors.push({field:'product',message:"__VBM_TEXT_t267__"});
    if(errors.length){
      event.preventDefault();this.ui.errors=errors;
      var first=errors[0],steps=C.steps(this.state);
      var matching=steps.find(function(step){return C.validate(this.state,step).some(function(e){return e.field===first.field&&e.bankId===first.bankId;});},this);
      if(matching)this.state.step=matching;if(first.bankId)this.ui.active=first.bankId;this.render();this.focus();return;
    }
    try{if(!this.prepareMail()){event.preventDefault();this.ui.errors=[{message:"__VBM_TEXT_t276__"}];this.render();return;}}
    catch(error){event.preventDefault();this.ui.errors=[{message:"__VBM_TEXT_mail_prepare_error__"}];this.render();this.focus();return;}
    var kind=C.route(this.state),requestCount=kind==='offerte'?C.count(this.state):(this.state.expectedCount||'');
    this.save();
    if(this.config.preview||this.config.designMode){
      event.preventDefault();
      this.ui.errors=[];
      this.root.querySelector('[data-errors]').innerHTML=this.renderCopy("<div class=\"q-note\" role=\"status\"><strong>__VBM_TEXT_t277__</strong> __VBM_TEXT_t278__</div>");
      this.announce("__VBM_TEXT_t279__");return;
    }
    Array.from(this.form.querySelectorAll('input[name^="contact["],textarea[name^="contact["],select[name^="contact["]')).forEach(function(el){if(!el.hasAttribute('data-post')&&!el.hasAttribute('data-quote-mail-field'))el.disabled=true;});
    var pending={id:C.uid(),kind:kind,count:requestCount,time:Date.now(),formId:this.config.formId,path:location.pathname};
    if(this.config.globalPopup){
      var target=new URL(location.href);target.searchParams.delete('contact_posted');target.searchParams.set('vbm_quote_receipt',pending.id);target.hash=this.config.formId;
      var returnField=this.form.querySelector('input[name="return_to"]');if(!returnField){returnField=document.createElement('input');returnField.type='hidden';returnField.name='return_to';this.form.appendChild(returnField);}
      returnField.value=target.pathname+target.search+target.hash;
    }
    safeWrite(this.pendingKey,pending);
    this.ui.submitting=true;
    this.ui.submissionId=pending.id;this.updateRestartControls();
    var send=this.form.querySelector('[data-send]');if(send){send.disabled=true;send.textContent=this.resolveText("__VBM_TEXT_t280__");}
    this.announce("__VBM_TEXT_t281__");
    var self=this;
    window.setTimeout(function(){
      if(!document.hidden&&self.ui.submitting&&self.ui.submissionId===pending.id){self.ui.submitting=false;self.updateRestartControls();var send=self.form.querySelector('[data-send]');if(send){send.disabled=false;send.textContent=self.resolveText(self.submitLabel());}}
    },20000);
  };
  Quote.prototype.receiptMatches=function(){
    var pending=safeRead(this.pendingKey);
    if(!this.config.globalPopup)return !!(pending&&pending.formId===this.config.formId&&Date.now()-pending.time<3600000);
    var receipt=new URLSearchParams(location.search).get('vbm_quote_receipt');
    if(!receipt||!/^vb-[a-z0-9-]+$/i.test(receipt)||location.hash!=='#'+this.config.formId)return false;
    return !pending||pending.id===receipt&&pending.path===location.pathname&&pending.formId===this.config.formId&&Date.now()-pending.time<3600000;
  };
  Quote.prototype.showSuccess=function(){
    this.ui.showingSuccess=true;this.ui.successDismissed=false;this.ui.submitting=false;this.ui.resume=null;this.cancelRestart(false);this.root.querySelector('[data-quote-fields]').hidden=true;this.root.querySelector('[data-quote-success]').hidden=false;this.aside.hidden=true;this.aside.parentElement.classList.add('is-success');this.open();this.success();
  };
  Quote.prototype.success=function(){
    var success=this.root.querySelector('[data-quote-success]'),pending=safeRead(this.pendingKey);
    if(!success||(this.config.globalPopup&&!this.receiptMatches()))return;
    success.focus({preventScroll:true});
    if(this.dialog&&this.dialog.open&&this.successTimer==null){var self=this;this.successTimer=window.setTimeout(function(){self.successTimer=null;if(self.dialog.open)self.close();},5000);}
    if(!pending||pending.formId!==this.config.formId||Date.now()-pending.time>3600000)return;
    var detail=this.root.querySelector('[data-success-detail]');
    var requestLabel=this.text('route_'+pending.kind)||this.text("t282");
    var received=this.text(pending.count?(Number(pending.count)===1?'success_one':'success_many'):'success_empty',{aanvraag:requestLabel,aantal:pending.count});
    if(detail)detail.innerHTML=this.renderCopy('<p>'+E(received)+'</p>'+(pending.kind==='showroom'?'<p>__VBM_TEXT_t283__</p>':pending.kind==='inmeten'?'<p>__VBM_TEXT_t284__</p>':''));
    var done=safeRead(this.doneKey)||[];
    if(!done.includes(pending.id)){
      var type={offerte:'centrale_offerte',inmeten:'centrale_inmeetaanvraag',advies:'centrale_adviesaanvraag',showroom:'centrale_showroomaanvraag'}[pending.kind];
      var options={dedupeId:pending.id,leadSource:'vbm_offertetool'};
      if(typeof window.vbmGoogleTrackLead==='function')window.vbmGoogleTrackLead(type,options);
      else{window.vbmMeasurementQueue=window.vbmMeasurementQueue||[];window.vbmMeasurementQueue.push({type:'lead',formType:type,options:options});}
      done.push(pending.id);safeWrite(this.doneKey,done.slice(-30));
    }
    safeRemove(this.key);
  };
  Quote.prototype.applyPrefill=async function(context){
    if(this.ui.resume)return;
    var request=this.state,params=new URLSearchParams(location.search);
    var handle=context?context.product:params.get('product'),collection=context?context.collection:params.get('collectie'),type=context?context.type:params.get('uitvoering'),montage=context?context.montage:params.get('montage'),inmeten=context?context.inmeten:params.get('inmeten'),advies=context?context.advies:params.get('advies');
    if(!handle&&!collection&&!type&&!montage&&!inmeten&&!advies)return;
    if(advies==='ja'){
      this.state.materialKnown='no';this.state.step='advies';this.render();this.save();return;
    }
    if(inmeten==='ja')this.state.measurement='us';
    if(montage==='ja')this.state.installation='us';
    if(!handle&&!collection&&!type){this.render();this.save();return;}
    if(type&&!['new','overzet'].includes(type))type=null;
    if(handle&&!/^[a-z0-9-]+$/.test(handle))return;
    var b=this.state.banks[0]||C.bank(1);if(!this.state.banks.length)this.state.banks.push(b);this.ui.active=b.id;
    if(type)b.type=type;
    if(collection)this.state.materialKnown='yes';
    if(collection&&this.config.materials.some(function(m){return m.handle===collection;}))b.material=collection;
    if(handle){
      this.state.materialKnown='yes';
      var materials=b.material?this.config.materials.filter(function(m){return m.handle===b.material;}):this.config.materials;
      for(var material of materials){
        try{var products=await this.catalog(material.handle);if(this.state!==request)return;var product=products.find(function(p){return p.handle===handle;});if(product){b.material=material.handle;b.product=product;var spec=await this.getSpec(product);if(this.state!==request)return;C.applySpec(b,spec);break;}}catch(e){if(this.state!==request)return;}
      }
      if(b.type&&b.material&&!this.materials(b).some(function(m){return m.handle===b.material;})){b.material='';b.product=null;b.spec=null;}
    }
    if(C.requiredProduct(b)&&(!b.product||b.product.handle!==C.requiredProduct(b)))await this.selectProduct(b,C.requiredProduct(b));
    if(this.state!==request)return;
    this.render();this.save();
  };
  var rawCatalog=Quote.prototype.catalog;
  Quote.prototype.catalog=async function(handle,retry){
    var loading=rawCatalog.call(this,handle,retry),entry=this.catalogs.get(handle),values=await loading;
    var storefront=location.origin,shop=new URL(this.config.shopUrl||storefront).origin;
    var valid=values.filter(function(p){
      try{var url=new URL(p.url,storefront);if(![storefront,shop].includes(url.origin)||url.username||url.password||(!url.pathname.includes('/products/')&&!(p.requestOnly&&url.pathname.endsWith('/pages/overzetvensterbanken'))))return false;p.url=url.href;return true;}catch(e){return false;}
    });
    if(values.length&&!valid.length){if(this.catalogs.get(handle)===entry)this.catalogs.delete(handle);throw new Error("__VBM_TEXT_t011__");}
    if(entry&&this.catalogs.get(handle)===entry)entry.resolved=valid;
    return valid;
  };
  function mount(scope){
    (scope.matches&&scope.matches('[data-vbm-quote-root]')?[scope]:Array.from(scope.querySelectorAll('[data-vbm-quote-root]'))).forEach(function(root){
      if(root.dataset.quoteReady)return;
      if(!root.hasAttribute('data-quote-global')&&document.querySelector('[data-quote-global]'))return;
      root.dataset.quoteReady='true';
      try{var instance=new Quote(root);if(!activeQuote||root.hasAttribute('data-quote-global')){activeQuote=instance;window.__vbmQuoteCurrent=instance;}}catch(e){
        var panel=root.querySelector('[data-step-content]');
        if(panel)panel.innerHTML='<p>De aanvraaghulp kan niet worden geladen. Je kunt je wensen mailen naar <a href="mailto:info@vensterbankopmaat.nl">info@vensterbankopmaat.nl</a>.</p>';
        if(window.console)console.error('Offertetool kon niet starten.',e);
      }
    });
  }
  window.__vbmQuoteBuild=C.VERSION;
  window.__vbmQuoteBootstrap=mount;
  mount(document);
  if(!window.__vbmQuoteLauncherBound){
    window.__vbmQuoteLauncherBound=true;
    document.addEventListener('click',function(event){
      var target=event.target&&event.target.closest?event.target.closest('[data-vbm-offerte-open],[data-quote-open],a[href="#offerte-aanvragen"]'):null;
      var quote=window.__vbmQuoteCurrent;
      if(!target||!quote)return;
      if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
      event.preventDefault();quote.opener=(target.dataset.offerteFocusReturn&&document.getElementById(target.dataset.offerteFocusReturn))||target;
      var base=target.dataset.offerteContext==='explicit'?{}:(quote.config.pageContext||{});
      quote.open({product:target.dataset.offerteProduct||base.product||'',collection:target.dataset.offerteCollectie||base.collection||'',type:target.dataset.offerteUitvoering||base.type||'',montage:target.dataset.offerteMontage||base.montage||'',inmeten:target.dataset.offerteInmeten||base.inmeten||'',advies:target.dataset.offerteAdvies||base.advies||''});
    });
    document.addEventListener('shopify:section:select',function(event){var quote=window.__vbmQuoteCurrent;if(quote&&quote.config.designMode&&event.target.contains(quote.root))quote.open();});
    window.addEventListener('hashchange',function(){var quote=window.__vbmQuoteCurrent;if(location.hash==='#offerte-aanvragen'&&quote)quote.open(quote.config.pageContext||{});});
  }
  if(location.hash==='#offerte-aanvragen'&&activeQuote)activeQuote.open(activeQuote.config.pageContext||{});
  document.addEventListener('shopify:section:load',function(event){var reopen=editorReopen;mount(event.target);var quote=window.__vbmQuoteCurrent;if(quote&&quote.config.designMode&&event.target.contains(quote.root)&&reopen){editorReopen=false;quote.open();}});
})();
